import { SYSTEM_BLACK_COLOR } from './theme'

export const ENVIRONMENT: string = process?.env?.NEXT_PUBLIC_ENVIRONMENT
  ? process?.env?.NEXT_PUBLIC_ENVIRONMENT?.toString().trim().toLowerCase()
  : 'dev'
export const IS_PRODUCTION: boolean = ENVIRONMENT == 'prod' ? true : false
export const IS_QA: boolean = ENVIRONMENT == 'dev' ? true : false
export const IS_LOCAL: boolean = ENVIRONMENT == 'local' ? true : false
export const HOST: string = process?.env?.NEXT_PUBLIC_HOST
  ? process?.env?.NEXT_PUBLIC_HOST.toString().trim()
  : ''
export const BLOG_HOST: string = process?.env?.NEXT_PUBLIC_BLOG_HOST
  ? process?.env?.NEXT_PUBLIC_BLOG_HOST.toString().trim()
  : ''
export const PRODUCTION_BLOG_HOST: string = process?.env
  ?.NEXT_PUBLIC_PRODUCTION_BLOG_HOST
  ? process?.env?.NEXT_PUBLIC_PRODUCTION_BLOG_HOST?.toString().trim()
  : ''
export const MEDIUM_BLOG: string = 'https://medium.com/practicalstream'
export const STREAMY3_GITHUB_PROFILE: string = 'https://github.com/streamy3'
export const SAAS_HUB_PROFILE: string =
  'https://www.saashub.com/practical-alternatives'
export const SLASH_DOT_PROFILE: string =
  'https://slashdot.org/software/p/Practical-Stream/'
export const SOURCE_FORGE_PROFILE: string =
  'https://sourceforge.net/software/product/Practical-Stream/'
export const SOFTWARE_SUGGEST_PROFILE: string =
  'https://www.softwaresuggest.com/practical-stream'
export const G2_PROFILE: string =
  'https://www.g2.com/products/practical-stream/reviews'
export const JUSTIA_TRADEMARK_OWNER: string =
  'https://trademarks.justia.com/owners/streamy3-llc-6278965/'
export const ISSUE_WIRE_PRESS_RELEASE: string =
  'https://www.issuewire.com/practical-stream-launches-new-audio-solution-to-turn-business-environments-into-spoken-meditations-with-background-music-1836435688752256'
export const GOOGLE_TRENDS_ID_URL: string =
  'https://www.google.com/search?kgmid=/g/11zj3m5433'
export const HOST_SUBDOMAINS_WILDCARD: string = process?.env
  ?.NEXT_PUBLIC_HOST_SUBDOMAINS_WILDCARD
  ? process?.env?.NEXT_PUBLIC_HOST_SUBDOMAINS_WILDCARD?.toString().trim()
  : ''
export const PRACTICAL_STREAM_INDEXED_DB_VERSION: number = 12
export const PRACTICAL_STREAM_INDEXED_DB_NAME: string = 's3'
export const PRACTICAL_STREAM_INDEXED_DB_SONG_CHUNKS_TABLE_NAME: string =
  'chunks'
export const PRACTICAL_STREAM_INDEXED_DB_SONG_CHUNKS_TABLE_KEY: string = 'key'
export const PRACTICAL_STREAM_INDEXED_DB_OFFLINE_MODE_SONGS_TABLE_NAME: string =
  'os'
export const PRACTICAL_STREAM_INDEXED_DB_OFFLINE_MODE_SONGS_TABLE_KEY: string =
  'key'
export const DEBUG_OFFLINE_MODE: boolean = !IS_PRODUCTION && false
export const DEBUG_OFFLINE_MODAL: boolean = !IS_PRODUCTION && false
export const SIMULATE_OFFLINE_FOR_PING: boolean = !IS_PRODUCTION && false
export const SEARCH_PAGE_DISPLAY_NAME: string = 'searchpage'
export const ACCOUNT_SETTINGS_PAGE_DISPLAY_NAME: string = 'accountsettingspage'
export const CONTACT_PAGE_DISPLAY_NAME: string = 'ContactPage'
export const HOME_PAGE_DISPLAY_NAME: string = 'HomePage'
export const FAVORITES_PAGE_DISPLAY_NAME: string = 'FavoritesPage'
export const PLAYLIST_PAGE_DISPLAY_NAME: string = 'PlaylistPage'
export const STUDIO_PAGE_DISPLAY_NAME: string = 'StudioPage'
export const FOUR_O_FOUR_PAGE_DISPLAY_NAME: string = 'FourOFourPage'
export const FIVE_HUNDRED_PAGE_DISPLAY_NAME: string = 'FiveHundredPage'
export const ERROR_PAGE_DISPLAY_NAME: string = 'ErrorPage'
export const USE_CDN: boolean = true
export const CDN_PERM_CACHE_FOLDER: string = 'perm/'
export const USE_ARWEAVED_APP_ICONS: boolean = false
export const INVITATION_PREPARED_STATUS: string = 'PREPARED'
export const INVITATION_CANCELLED_STATUS: string = 'CANCELLED'
export const INVITATION_ACCEPTED_STATUS: string = 'ACCEPTED'
export const STRIPE_SUBSCRIPTION_STATUS_ACTIVE: string = 'active'
export const STRIPE_SUBSCRIPTION_STATUS_TRIALING: string = 'trialing'
export const STRIPE_SUBSCRIPTION_STATUS_PAST_DUE: string = 'past_due'
export const STRIPE_SUBSCRIPTION_STATUS_INCOMPLETE: string = 'incomplete'
export const STRIPE_SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED: string =
  'incomplete_expired'
export const STRIPE_SUBSCRIPTION_STATUS_CANCELED: string = 'canceled'
export const STRIPE_SUBSCRIPTION_STATUS_UNPAID: string = 'unpaid'
export const STRIPE_SUBSCRIPTION_STATUS_PAUSED: string = 'paused'
export const STRIPE_SUBSCRIPTION_INTERVAL_YEARLY: string = 'year'
export const STRIPE_SUBSCRIPTION_INTERVAL_MONTHLY: string = 'month'
export const PROVISIONING_HARDWARE_PLACEHOLDER: string = 'PROVISIONED'
export const DEBUG_MODE: boolean = false
export const USE_SENTRY_APP_MONITORING_LOCAL: boolean = false
export const USE_SENTRY_APP_MONITORING_QA: boolean = false
export const USE_SENTRY_APP_MONITORING_PRODUCTION: boolean = false
export const KIOSK_CHROME_EXTENSION_ID_ON_PRODUCTION_DEVICES: string =
  'kpoaikggocjlaiibgdgcdocdamnnfoaf'
export const KIOSK_CHROME_EXTENSION_ID_IN_LOCAL_CHROME_BROWSER: string =
  'kbihdegeoandhkbjcdjdeilchafdajje' //'ochaohdoehnjfjeefbmobcmchddoijed'
export const DEFAULT_KIOSK_RESTART_TIME_STRING: string = '11:59 PM'
export const DEFAULT_APP_RELOAD_TIME_STRING: string = '11:59 PM'
export const DEFAULT_KIOSK_RESTART_TIME_MINUTES_PAST_MIDNIGHT: number = 1439
export const DEFAULT_APP_RELOAD_TIME_MINUTES_PAST_MIDNIGHT: number = 1439
export const DEBUG_MONITOR_SCHEDULE_TIMERS: boolean = false && !IS_PRODUCTION
export const PRODUCTION_HARDWARE_USER_WEB2_USER_ID: string =
  '0x44f1931E7053A06ffF8Eac3a837B8985597f19C5'
export const PRODUCTION_HOST: string = process?.env?.NEXT_PUBLIC_PRODUCTION_HOST
  ? process?.env?.NEXT_PUBLIC_PRODUCTION_HOST?.toString().trim()
  : 'https://practical.stream'
export const TEST_SOFTWARE_TIER_REGULAR_RELOADS: boolean = false
export const USE_SOFTWARE_TIER_REGULAR_RELOADS: boolean = false
export const USE_PRACTICAL_POD_REGULAR_RESTARTS: boolean = true
export const USE_APP_MINIMUM_VERSION_RELOADS: boolean = false
export const TRACE_APP_VERSION_RELOAD_CHECK: boolean = false //!IS_PRODUCTION
export const MAXIMUM_MINUTES_TO_NOT_RELOAD_AFTER_APP_NEEDS_RELOAD: number = 60
export const SECONDS_TO_PING_FOR_OFFLINE_OR_NEW_APP_VERSION: number =
  !USE_APP_MINIMUM_VERSION_RELOADS ? 5 : IS_PRODUCTION ? 900 : 60
export const SECONDS_TO_PING_FOR_OFFLINE_OR_NEW_APP_VERSION_MOBILE_ONLY: number =
  !USE_APP_MINIMUM_VERSION_RELOADS ? 20 : IS_PRODUCTION ? 900 : 60
export const POST_NEW_APP_VERSION_RELOAD_QUERYSTRING_FIELD: string = 'av'
export const POST_NEW_APP_VERSION_RELOAD_QUERYSTRING_FIELD_VALUE: string = '1'
export const FORCE_NOT_PRACTICAL_POD: boolean = false
export const FORCE_PRACTICAL_POD: boolean = false
export const FORCE_NO_PLAYLIST_EDITS_PRACTICAL_POD: boolean = false
export const P3_API_DOMAIN: string = process?.env?.NEXT_PUBLIC_P3_API_DOMAIN
  ? process?.env?.NEXT_PUBLIC_P3_API_DOMAIN.toString().trim()
  : ''
export const GOOGLE_PLACES_API_KEY: string = process?.env
  ?.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY
  ? process?.env?.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY?.toString().trim()
  : ''
export const HARDWARE_DEVICE_SKU: string = process?.env
  ?.NEXT_PUBLIC_HARDWARE_DEVICE_SKU
  ? process?.env?.NEXT_PUBLIC_HARDWARE_DEVICE_SKU
  : ''
export const SOFTWARE_SKU: string = process?.env?.NEXT_PUBLIC_SOFTWARE_SKU
  ? process?.env?.NEXT_PUBLIC_SOFTWARE_SKU
  : ''
export const HELP_EMAIL: string = process?.env?.NEXT_PUBLIC_HELP_EMAIL
  ? process?.env?.NEXT_PUBLIC_HELP_EMAIL
  : ''
export const HELP_EMAIL_ES: string = process?.env?.NEXT_PUBLIC_HELP_EMAIL_ES
  ? process?.env?.NEXT_PUBLIC_HELP_EMAIL_ES
  : ''
export const HELP_EMAIL_FR: string = process?.env?.NEXT_PUBLIC_HELP_EMAIL_FR
  ? process?.env?.NEXT_PUBLIC_HELP_EMAIL_FR
  : ''
export const RETURNS_EMAIL: string = process?.env?.NEXT_PUBLIC_RETURNS_EMAIL
  ? process?.env?.NEXT_PUBLIC_RETURNS_EMAIL
  : ''
export const RETURNS_EMAIL_ES: string = process?.env
  ?.NEXT_PUBLIC_RETURNS_EMAIL_ES
  ? process?.env?.NEXT_PUBLIC_RETURNS_EMAIL_ES
  : ''
export const RETURNS_EMAIL_FR: string = process?.env
  ?.NEXT_PUBLIC_RETURNS_EMAIL_FR
  ? process?.env?.NEXT_PUBLIC_RETURNS_EMAIL_FR
  : ''
export const CONTACT_EMAIL: string = process?.env?.NEXT_PUBLIC_CONTACT_EMAIL
  ? process?.env?.NEXT_PUBLIC_CONTACT_EMAIL
  : ''
export const CONTACT_EMAIL_ES: string = process?.env
  ?.NEXT_PUBLIC_CONTACT_EMAIL_ES
  ? process?.env?.NEXT_PUBLIC_CONTACT_EMAIL_ES
  : ''
export const CONTACT_EMAIL_FR: string = process?.env
  ?.NEXT_PUBLIC_CONTACT_EMAIL_FR
  ? process?.env?.NEXT_PUBLIC_CONTACT_EMAIL_FR
  : ''
export const CONTACT_PHONE: string = process?.env?.NEXT_PUBLIC_CONTACT_PHONE
  ? process?.env?.NEXT_PUBLIC_CONTACT_PHONE.toString().trim()
  : ''
export const SHOW_CONTACT_PHONE: boolean = false
export const ACCESSIBILITY_EMAIL: string = process?.env
  ?.NEXT_PUBLIC_ACCESSIBILITY_EMAIL
  ? process?.env?.NEXT_PUBLIC_ACCESSIBILITY_EMAIL
  : ''
export const ACCESSIBILITY_EMAIL_ES: string = process?.env
  ?.NEXT_PUBLIC_ACCESSIBILITY_EMAIL_ES
  ? process?.env?.NEXT_PUBLIC_ACCESSIBILITY_EMAIL_ES
  : ''
export const ACCESSIBILITY_EMAIL_FR: string = process?.env
  ?.NEXT_PUBLIC_ACCESSIBILITY_EMAIL_FR
  ? process?.env?.NEXT_PUBLIC_ACCESSIBILITY_EMAIL_FR
  : ''
export const IPIFY_SERVICE_URL: string = process?.env
  ?.NEXT_PUBLIC_IPIFY_SERVICE_URL
  ? process?.env?.NEXT_PUBLIC_IPIFY_SERVICE_URL?.toString()
  : ''
export const GEOLOCATION_SERVICE_URL: string =
  process?.env.NEXT_PUBLIC_GEOLOCATION_SERVICE_URL?.toString().trim()
    ? process?.env?.NEXT_PUBLIC_GEOLOCATION_SERVICE_URL
    : ''
export const TEST_BRITISH_IP_ADDRESS: string = '178.238.11.6'
export const TEST_BRITISH_USER: boolean = false
export const TEST_FRENCH_IP_ADDRESS: string = '91.160.93.4'
export const TEST_FRENCH_USER: boolean = false
export const TEST_KOREAN_IP_ADDRESS: string = '180.228.172.138'
export const TEST_KOREAN_USER: boolean = false
export const TEST_CANADIAN_IP_ADDRESS: string = '192.206.151.131'
export const TEST_CANADIAN_USER: boolean = false
export const DISABLE_RIGHT_CLICK: boolean = process?.env
  ?.NEXT_PUBLIC_DISABLE_RIGHT_CLICK
  ? process?.env?.NEXT_PUBLIC_DISABLE_RIGHT_CLICK?.toString().trim() == 'true'
  : false
export const APP_DOMAIN: string = process?.env?.NEXT_PUBLIC_APP_DOMAIN
  ? process?.env?.NEXT_PUBLIC_APP_DOMAIN?.toString().trim()
  : ''
export const ACCOUNT_SETTINGS_REDIRECT_UUID: string = process?.env
  ?.NEXT_PUBLIC_ACCOUNT_SETTINGS_REDIRECT_UUID
  ? process?.env?.NEXT_PUBLIC_ACCOUNT_SETTINGS_REDIRECT_UUID?.toString().trim()
  : ''
export const MAGIC_LINK_API_KEY: string = process?.env
  ?.NEXT_PUBLIC_MAGIC_LINK_API_KEY
  ? process.env.NEXT_PUBLIC_MAGIC_LINK_API_KEY.toString().trim()
  : ''
export const SUBSCRIPTION_FEE: number = process?.env
  ?.NEXT_PUBLIC_SUBSCRIPTION_FEE
  ? parseFloat(process?.env?.NEXT_PUBLIC_SUBSCRIPTION_FEE)
  : 8.34
export const SUBSCRIPTION_FEE_HARDWARE: number = process?.env
  ?.NEXT_PUBLIC_SUBSCRIPTION_FEE_HARDWARE
  ? parseFloat(process?.env?.NEXT_PUBLIC_SUBSCRIPTION_FEE_HARDWARE)
  : 192.0
export const DARK_MODE_DEFAULT_COOKIE_NAME: string = process?.env
  ?.NEXT_PUBLIC_DARK_MODE_DEFAULT_COOKIE_NAME
  ? process?.env?.NEXT_PUBLIC_DARK_MODE_DEFAULT_COOKIE_NAME?.toString().trim()
  : ''
export const DARK_MODE_DEFAULT_COOKIE_NAME_DARK: string = process?.env
  ?.NEXT_PUBLIC_DARK_MODE_DEFAULT_COOKIE_NAME_DARK
  ? process?.env?.NEXT_PUBLIC_DARK_MODE_DEFAULT_COOKIE_NAME_DARK?.toString().trim()
  : ''
export const DARK_MODE_DEFAULT_COOKIE_NAME_LIGHT: string = process?.env
  ?.NEXT_PUBLIC_DARK_MODE_DEFAULT_COOKIE_NAME_LIGHT
  ? process?.env?.NEXT_PUBLIC_DARK_MODE_DEFAULT_COOKIE_NAME_LIGHT?.toString().trim()
  : ''
export const CHECK_NOTIFICATIONS_FREQUENCY_SECONDS: number = process?.env
  ?.NEXT_PUBLIC_CHECK_NOTIFICATIONS_FREQUENCY_SECONDS
  ? parseInt(
      process?.env?.NEXT_PUBLIC_CHECK_NOTIFICATIONS_FREQUENCY_SECONDS?.toString().trim(),
    )
  : 30
export const HANDLE_NETWORK_CONNECTION_PING_FREQUENCY_SECONDS: number = process
  ?.env?.NEXT_PUBLIC_HANDLE_NETWORK_CONNECTION_PING_FREQUENCY_SECONDS
  ? parseInt(
      process?.env?.NEXT_PUBLIC_HANDLE_NETWORK_CONNECTION_PING_FREQUENCY_SECONDS?.toString().trim(),
    )
  : 30
export const HANDLE_NETWORK_CONNECTION_PING_FREQUENCY_RETRY_SECONDS: number =
  process?.env
    ?.NEXT_PUBLIC_HANDLE_NETWORK_CONNECTION_PING_FREQUENCY_RETRY_SECONDS
    ? parseInt(
        process?.env?.NEXT_PUBLIC_HANDLE_NETWORK_CONNECTION_PING_FREQUENCY_RETRY_SECONDS?.toString().trim(),
      )
    : 30
export const ARWEAVE_GATEWAY_MAIN = process?.env?.NEXT_PUBLIC_ARWEAVE_NODE_MAIN
  ? process?.env?.NEXT_PUBLIC_ARWEAVE_NODE_MAIN?.toString().trim()
  : 'https://arweave.net/'
const USE_MAIN_ARWEAVE_NODE: boolean = false
export const ARWEAVE_GATEWAY: string = USE_MAIN_ARWEAVE_NODE
  ? ARWEAVE_GATEWAY_MAIN
  : process?.env?.NEXT_PUBLIC_ARWEAVE_NODE
    ? process?.env?.NEXT_PUBLIC_ARWEAVE_NODE?.toString().trim()
    : ''
export const INSTALL_PWA_OVERLAY_COOKIE_NAME: string = process?.env
  ?.NEXT_PUBLIC_INSTALL_PWA_OVERLAY_COOKIE_NAME
  ? process?.env?.NEXT_PUBLIC_INSTALL_PWA_OVERLAY_COOKIE_NAME?.toString().trim()
  : ''
export const USE_ENV_PROTECTION_MODAL: boolean =
  process?.env?.NEXT_PUBLIC_USE_ENV_PROTECTION_MODAL &&
  process?.env?.NEXT_PUBLIC_USE_ENV_PROTECTION_MODAL?.toString()
    .trim()
    .toLowerCase() == 'true'
    ? true
    : false
export const USE_QUICK_SEARCH_COOKIE_NAME: string = process?.env
  ?.NEXT_PUBLIC_USE_QUICK_SEARCH_COOKIE_NAME
  ? process?.env?.NEXT_PUBLIC_USE_QUICK_SEARCH_COOKIE_NAME?.toString().trim()
  : ''
export const ENV_PROTECTION_COOKIE_NAME: string = process?.env
  ?.NEXT_PUBLIC_ENV_PROTECTION_COOKIE_NAME
  ? process?.env?.NEXT_PUBLIC_ENV_PROTECTION_COOKIE_NAME?.toString().trim()
  : ''
export const SELECTED_LANGUAGE_COOKIE_NAME: string = process?.env
  ?.NEXT_PUBLIC_SELECTED_LANGUAGE_COOKIE_NAME
  ? process?.env?.NEXT_PUBLIC_SELECTED_LANGUAGE_COOKIE_NAME?.toString().trim()
  : ''
export const AUTOPLAY_INFO_MODAL_SHOWN_COOKIE_NAME: string = process?.env
  ?.NEXT_PUBLIC_AUTOPLAY_INFO_MODAL_SHOWN_COOKIE_NAME
  ? process?.env?.NEXT_PUBLIC_AUTOPLAY_INFO_MODAL_SHOWN_COOKIE_NAME?.toString().trim()
  : ''
export const SCHEDULE_AUTOPLAY_ENABLED: boolean = process?.env
  ?.NEXT_PUBLIC_SCHEDULE_AUTOPLAY_ENABLED
  ? process?.env?.NEXT_PUBLIC_SCHEDULE_AUTOPLAY_ENABLED?.toString() == 'true'
    ? true
    : false
  : false
export const CURRENT_STRIPE_SUBSCRIPTION_INTERVAL: string = process?.env
  ?.NEXT_PUBLIC_CURRENT_STRIPE_SUBSCRIPTION_INTERVAL
  ? process?.env?.NEXT_PUBLIC_CURRENT_STRIPE_SUBSCRIPTION_INTERVAL?.toString()
  : ''
export const CURRENT_STRIPE_SUBSCRIPTION_INTERVAL_HARDWARE: string = process
  ?.env?.NEXT_PUBLIC_CURRENT_STRIPE_SUBSCRIPTION_INTERVAL_HARDWARE
  ? process?.env?.NEXT_PUBLIC_CURRENT_STRIPE_SUBSCRIPTION_INTERVAL_HARDWARE?.toString()
  : ''
export const STRIPE_PRODUCT_ID_SOFTWARE: string = process?.env
  ?.NEXT_PUBLIC_STRIPE_PRODUCT_ID
  ? process?.env?.NEXT_PUBLIC_STRIPE_PRODUCT_ID?.toString()
  : ''
export const STRIPE_PRODUCT_ID_HARDWARE: string = process?.env
  ?.NEXT_PUBLIC_STRIPE_PRODUCT_ID_HARDWARE
  ? process?.env?.NEXT_PUBLIC_STRIPE_PRODUCT_ID_HARDWARE?.toString()
  : ''
export const PRESETS_AND_STATIONS_ADMIN_WEB2_USER_ID: string = process?.env
  ?.NEXT_PUBLIC_PRESETS_AND_STATIONS_ADMIN_WEB2_USER_ID
  ? process?.env?.NEXT_PUBLIC_PRESETS_AND_STATIONS_ADMIN_WEB2_USER_ID?.toString().trim()
  : ''
export const PRACTICAL_STREAM_CDN_ADDRESS: string = process?.env
  ?.NEXT_PUBLIC_PRACTICAL_STREAM_CDN_ADDRESS
  ? process?.env?.NEXT_PUBLIC_PRACTICAL_STREAM_CDN_ADDRESS?.toString().trim()
  : ''
export const USE_CONTENT_SECURITY_POLICIES: boolean = process?.env
  ?.NEXT_PUBLIC_USE_CONTENT_SECURITY_POLICIES
  ? process?.env?.NEXT_PUBLIC_USE_CONTENT_SECURITY_POLICIES?.toString() ==
    'true'
  : false
export const USE_X_CONTENT_TYPE_OPTIONS_HEADER = process?.env
  ?.NEXT_PUBLIC_USE_X_CONTENT_TYPE_OPTIONS_HEADER
  ? process?.env?.NEXT_PUBLIC_USE_X_CONTENT_TYPE_OPTIONS_HEADER?.toString() ==
    'true'
  : false
export const MAXIMUM_NUMBER_PLAYLISTS: number = process?.env
  ?.NEXT_PUBLIC_MAXIMUM_NUMBER_PLAYLISTS
  ? parseInt(process?.env?.NEXT_PUBLIC_MAXIMUM_NUMBER_PLAYLISTS)
  : 500
export const MAXIMUM_NUMBER_CUSTOM_PLAYLIST_ENTRIES: number = process?.env
  ?.NEXT_PUBLIC_MAXIMUM_NUMBER_CUSTOM_PLAYLIST_ENTRIES
  ? parseInt(process?.env?.NEXT_PUBLIC_MAXIMUM_NUMBER_CUSTOM_PLAYLIST_ENTRIES)
  : 400
export const MAXIMUM_PRESET_OR_STATION_ENTRIES: number = process?.env
  ?.NEXT_PUBLIC_MAXIMUM_PRESET_OR_STATION_ENTRIES
  ? parseInt(process?.env?.NEXT_PUBLIC_MAXIMUM_PRESET_OR_STATION_ENTRIES)
  : 100000
export const CHEAPER_ALTERNATIVE = {
  value: 'CHEAPER_ALTERNATIVE',
  label: 'Cheaper Alternative',
}
export const WHAT_KIND_OF_MUSIC = {
  value: 'WHAT_KIND_OF_MUSIC',
  label: 'What Kind Of Music',
}
export const WHY_CANT_I_STREAM_FOR_FREE = {
  value: 'WHY_CANT_I_STREAM_FOR_FREE',
  label: "Why Can't Stream For Free?",
}
export const HOW_DO_YOU_PAY_ARTISTS = {
  value: 'HOW_DO_YOU_PAY_ARTISTS',
  label: 'How Do You Pay Artists?',
}
function formatLocalISOForCookieExpires(date: Date | null): string {
  let ret: string = '2029-12-28T03:24:00'
  try {
    if (date != null) {
      const year = date.getFullYear()
      const month: string = (date.getMonth() + 1).toString().padStart(2, '0')
      const day: string = date.getDate().toString().padStart(2, '0')
      const hours: string = date.getHours().toString().padStart(2, '0')
      const minutes: string = date.getMinutes().toString().padStart(2, '0')
      const seconds: string = date.getSeconds().toString().padStart(2, '0')
      ret = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    }
  } catch {}
  return ret
}
const cookieExpiration: string = formatLocalISOForCookieExpires(
  new Date(new Date().setFullYear(new Date().getFullYear() + 4)),
)
export const COOKIE_CONFIG = {
  path: '/',
  domain:
    HOST == 'http://localhost:3000' || HOST == 'https://localhost:3000'
      ? 'localhost'
      : APP_DOMAIN,
  expires: new Date(cookieExpiration),
  sameSite: true,
}
export const TERMS_OF_USE_EFFECTIVE_STRING = 'January 14, 2026'
export const TERMS_OF_USE_EFFECTIVE_STRING_ES = '14 de enero de 2026'
export const TERMS_OF_USE_EFFECTIVE_STRING_FR = '14 janvier 2026'
export const TERMS_OF_USE_EFFECTIVE_STRING_KO = '2026년 1월 14일'
export const TERMS_OF_USE_EFFECTIVE_KO = (
  <>
    <span
      aria-hidden={true}
      style={{
        whiteSpace: 'nowrap',
      }}
    >
      2026년
    </span>{' '}
    <span
      style={{
        whiteSpace: 'nowrap',
      }}
      aria-hidden={true}
    >
      1월
    </span>{' '}
    <span
      style={{
        whiteSpace: 'nowrap',
      }}
      aria-hidden={true}
    >
      14일
    </span>
  </>
)
export const TERMS_OF_USE_LAST_MODIFIED_JSON_LD_STRING = '2022-08-24T08:48:00Z'
export const PRIVACY_POLICY_EFFECTIVE_STRING = 'August 24, 2022'
export const PRIVACY_POLICY_EFFECTIVE_STRING_ES = '24 de Agosto de 2022'
export const PRIVACY_POLICY_EFFECTIVE_STRING_FR = '24 Août 2022'
export const PRIVACY_POLICY_EFFECTIVE_STRING_KO = '2022년 8월 24일'
export const PRIVACY_POLICY_LAST_MODIFIED_JSON_LD_STRING =
  '2025-12-18T08:48:00Z'
export const PRIVACY_POLICY_EFFECTIVE_KO = (
  <>
    <span
      aria-hidden={true}
      style={{
        whiteSpace: 'nowrap',
      }}
    >
      2022년
    </span>{' '}
    <span
      aria-hidden={true}
      style={{
        whiteSpace: 'nowrap',
      }}
    >
      8월
    </span>{' '}
    <span
      aria-hidden={true}
      style={{
        whiteSpace: 'nowrap',
      }}
    >
      24일
    </span>
  </>
)
export const BILLING_COMPLETED_LAST_MODIFIED_JSON_LD_STRING =
  '2026-10-20T08:48:00Z'
export const RETURNS_POLICY_EFFECTIVE_STRING = 'April 24, 2024'
export const RETURNS_POLICY_EFFECTIVE_STRING_ES = '24 de abril de 2024'
export const RETURNS_POLICY_EFFECTIVE_STRING_FR = '24 avril 2024'
export const RETURNS_POLICY_EFFECTIVE_STRING_KO = '2024년 4월 24일'
export const SOFTWARE_REFUND_POLICY_EFFECTIVE_STRING = 'January 1, 2026'
export const SOFTWARE_REFUND_POLICY_EFFECTIVE_STRING_ES = '1 de enero de 2026'
export const SOFTWARE_REFUND_POLICY_EFFECTIVE_STRING_FR = '1er janvier 2026'
export const SOFTWARE_REFUND_POLICY_EFFECTIVE_STRING_KO = '2026년 1월 1일'
export const DECLARATION_OF_RESPONSIBLE_USE_OF_AI_DATE_STRING =
  'January 7, 2026'
export const DECLARATION_OF_RESPONSIBLE_USE_OF_AI_DATE_STRING_ES =
  '7 de enero de 2026'
export const DECLARATION_OF_RESPONSIBLE_USE_OF_AI_DATE_STRING_FR =
  '7er janvier 2026'
export const DECLARATION_OF_RESPONSIBLE_USE_OF_AI_DATE_STRING_KO =
  '2026년 7월 1일'
export const RETURNS_POLICY_EFFECTIVE_KO = (
  <>
    <span
      aria-hidden={true}
      style={{
        whiteSpace: 'nowrap',
      }}
    >
      2024년
    </span>{' '}
    <span
      aria-hidden={true}
      style={{
        whiteSpace: 'nowrap',
      }}
    >
      4월
    </span>{' '}
    <span
      aria-hidden={true}
      style={{
        whiteSpace: 'nowrap',
      }}
    >
      24일
    </span>
  </>
)
export const FILESYSTEM_CONTENT_SECURITY_SOURCE: string = 'filesystem:'
export const MEDIA_STREAM_CONTENT_SECURITY_SOURCE: string = 'mediastream:'
export const BLOB_URLS_CONTENT_SECURITY_SOURCE: string = 'blob:'
export const DATA_URLS_CONTENT_SECURITY_SOURCE: string = 'data:'
export const MAGIC_LINK_CONTENT_SECURITY_SOURCE: string = 'https://*.magic.link'
export const VIDEO_PLAYER_CONTENT_SECURITY_SOURCES = 'https://*.2mdn.net'
export const IPIFY_CONTENT_SECURITY_SOURCES: string = 'https://*.ipify.org'
export const LENS_CONTENT_SECURITY_SOURCES: string = 'https://*.lens.dev '
export const BASE_RPC_CONTENT_SECURITY_SOURCE: string = 'https://*.base.org'
export const VERCEL_CONTENT_SECURITY_SOURCE: string =
  'https://vercel.live https://vercel.com'
export const VERCLE_PUSHERS_CONTENT_SECURITY_SOURCE: string =
  '*.pusher.com *.pusherapp.com'
export const BLOCKDAEMON_CONTENT_SECURITY_SOURCES: string =
  'https://*.blockdaemon.com'
export const GEOLOCATION_CONTENT_SECURITY_SOURCES: string =
  'https://*.geolocation-db.com https://ipapi.co/json'
export const WALLET_CONNECT_CONTENT_SECURITY_SOURCES: string =
  'wss://*.walletconnect.org wss://*.walletlink.org wss://*.walletconnect.com https://*.walletlink.org https://*.walletconnect.com https://*.walletconnect.org'
export const COIN_CONVERT_CONTENT_SECURITY_SOURCES: string =
  'https://*.coinconvert.net'
export const GOOGLE_CONTENT_SECURITY_SOURCES: string =
  'https://securepubads.g.doubleclick.net https://googleads.g.doubleclick.net https://*.googlesyndication.com https://*.googlesyndication.com https://*.googleapis.com https://*.google-analytics.com https://www.google.com https://google.com https://*.googletagservices.com https://*.gstatic.com https://*.googleusercontent.com'
export const CHAIN_ETHEREUM_MAINNET: number = 1
export const MAXIMUM_PLAYLIST_INTERNAL_NAME_CHARACTERS: number = 96
export const MAXIMUM_PLAYLIST_INTERNAL_DESCRIPTION_CHARACTERS: number = 256
export const GLOBAL_RAW_ENTRIES_ARTISTS_AND_GENRECONTRACTS_FETCH_AND_RESPONSE_CACHE_REVALIDATE_MINUTES: number =
  IS_PRODUCTION ? 720 : 30
export const PRESET_SAMPLES_FETCH_AND_RESPONSE_CACHE_REVALIDATE_MINUTES: number =
  IS_PRODUCTION ? 720 : 30
export const PLACES_PRESET_MODE: boolean = true
export const MIN_PRICE_SOUNDTRACK_YOUR_BRAND: number = 35
export const MIN_PRICE_SOUNDTRACK_YOUR_BRAND_STR: string = '$35'
export const MIN_PRICE_SOUNDTRACK_YOUR_BRAND_STR_ALT: string = '35.00'
export const MIN_PRICE_MOOD_MEDIA: number = 30
export const MIN_PRICE_MOOD_MEDIA_STR: string = '$30'
export const MIN_PRICE_MOOD_MEDIA_STR_ALT: string = '30.00'
export const MIN_PRICE_ROCKBOT: number = 24
export const MIN_PRICE_ROCKBOT_STR: string = '$24'
export const MIN_PRICE_ROCKBOT_STR_ALT: string = '24.00'
export const MIN_PRICE_CLOUDCOVER: number = 17
export const MIN_PRICE_CLOUDCOVER_STR: string = '$17'
export const MIN_PRICE_CLOUDCOVER_STR_ALT: string = '17.00'
export const MIN_PRICE_JUKEBOXY: number = 20
export const MIN_PRICE_JUKEBOXY_STR: string = '$20'
export const MIN_PRICE_JUKEBOXY_STR_ALT: string = '20.00'
export const MAX_PRICE_SOUNDTRACK_YOUR_BRAND: number = 35
export const MAX_PRICE_SOUNDTRACK_YOUR_BRAND_STR: string = '$35'
export const MAX_PRICE_MOOD_MEDIA: number = 60
export const MAX_PRICE_MOOD_MEDIA_STR: string = '$60'
export const MAX_PRICE_MOOD_MEDIA_STR_ALT: string = '60.00'
export const MAX_PRICE_ROCKBOT: number = 30
export const MAX_PRICE_ROCKBOT_STR: string = '$30'
export const MAX_PRICE_CLOUDCOVER: number = 35
export const MAX_PRICE_CLOUDCOVER_STR: string = '$35'
export const MAX_PRICE_JUKEBOXY: number = 30
export const MAX_PRICE_JUKEBOXY_STR: string = '$30'
export const CURRENCY_SYMBOL_EURO: string = '€'
export const CURRENCY_SYMBOL_BRITISH_POUND: string = '£'
export const CURRENCY_SYMBOL_US_DOLLAR: string = '$'
export const CURRENCY_SYMBOL_CANADA_DOLLAR: string = 'CA$'
export const ISO_4217_CURRENCY_CODE_CANADA_DOLLAR: string = 'CAD'
export const ISO_4217_CURRENCY_CODE_US_DOLLAR: string = 'USD'
export const ISO_4217_CURRENCY_CODE_BRITISH_POUND: string = 'GBP'
export const ISO_4217_CURRENCY_CODE_EURO: string = 'EUR'
export const DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_USD: string = '5.00'
export const DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_EURO: string = '5.00'
export const DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_POUND: string = '4.50'
export const DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_CAD: string = '7.00'
export const DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_USD_NUM: number =
  parseFloat(DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_USD)
export const DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_EURO_NUM: number =
  parseFloat(DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_EURO)
export const DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_POUND_NUM: number =
  parseFloat(DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_POUND)
export const DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_CAD_NUM: number =
  parseFloat(DEFAULT_100_TOKEN_BRAND_STUDIO_CREDITS_PRICE_CAD)
export const DEFAULT_SUBSCRIPTION_PRICE_USD: string = '8.34'
export const DEFAULT_SUBSCRIPTION_PRICE_EURO: string = '7.32'
export const DEFAULT_SUBSCRIPTION_PRICE_POUND: string = '6.22'
export const DEFAULT_SUBSCRIPTION_PRICE_CAD: string = '11.56'
export const DEFAULT_SUBSCRIPTION_PRICE_USD_HARDWARE: string = '192.00'
export const DEFAULT_SUBSCRIPTION_PRICE_USD_HARDWARE_NO_ZEROES: string = '192'
export const DEFAULT_SUBSCRIPTION_PRICE_EURO_HARDWARE: string = '168.55'
export const DEFAULT_SUBSCRIPTION_PRICE_POUND_HARDWARE: string = '143.15'
export const DEFAULT_SUBSCRIPTION_PRICE_CAD_HARDWARE: string = '266.06'
export const DEFAULT_SUBSCRIPTION_PRICE_USD_NUM: number = parseFloat(
  DEFAULT_SUBSCRIPTION_PRICE_USD,
)
export const DEFAULT_SUBSCRIPTION_PRICE_EURO_NUM: number = parseFloat(
  DEFAULT_SUBSCRIPTION_PRICE_EURO,
)
export const DEFAULT_SUBSCRIPTION_PRICE_POUND_NUM: number = parseFloat(
  DEFAULT_SUBSCRIPTION_PRICE_POUND,
)
export const DEFAULT_SUBSCRIPTION_PRICE_CAD_NUM: number = parseFloat(
  DEFAULT_SUBSCRIPTION_PRICE_CAD,
)
export const DEFAULT_SUBSCRIPTION_PRICE_USD_HARDWARE_NUM: number = parseFloat(
  DEFAULT_SUBSCRIPTION_PRICE_USD_HARDWARE,
)
export const DEFAULT_SUBSCRIPTION_PRICE_EURO_HARDWARE_NUM: number = parseFloat(
  DEFAULT_SUBSCRIPTION_PRICE_EURO_HARDWARE,
)
export const DEFAULT_SUBSCRIPTION_PRICE_POUND_HARDWARE_NUM: number = parseFloat(
  DEFAULT_SUBSCRIPTION_PRICE_POUND_HARDWARE,
)
export const DEFAULT_SUBSCRIPTION_PRICE_CAD_HARDWARE_NUM: number = parseFloat(
  DEFAULT_SUBSCRIPTION_PRICE_CAD_HARDWARE,
)
export const PRIMARY_IMAGE_PLACEHOLDER_LOCAL_DARK_AVIF: string =
  '/images/c9c3f53e-2764-11ed-a261-0242ac120002.avif'
export const PRIMARY_IMAGE_PLACEHOLDER_LOCAL_LIGHT_AVIF: string =
  '/images/8126548e-2764-11ed-a261-0242ac120002.avif'
export const PRIMARY_IMAGE_PLACEHOLDER_LOCAL_DARK_PNG: string =
  '/images/c9c3f53e-2764-11ed-a261-0242ac120002.png'
export const PRIMARY_IMAGE_PLACEHOLDER_LOCAL_LIGHT_PNG: string =
  '/images/8126548e-2764-11ed-a261-0242ac120002.png'
export const IOS_TRAY_IMAGE_LOCAL_AVIF: string =
  '/images/d09ed056-74f6-11ed-a1eb-0242ac120002.avif'
export const IOS_TRAY_IMAGE_LOCAL_PNG: string =
  '/images/d09ed056-74f6-11ed-a1eb-0242ac120002.png'
export const IOS_CONTEXT_MENU_IMAGE_LOCAL_AVIF: string =
  '/images/edacfede-74f6-11ed-a1eb-0242ac120002.avif'
export const IOS_CONTEXT_MENU_IMAGE_LOCAL_PNG: string =
  '/images/edacfede-74f6-11ed-a1eb-0242ac120002.png'
export const IOS_ADD_TO_HOME_SCREEN_IMAGE_LOCAL_AVIF: string =
  '/images/f736a05e-74f6-11ed-a1eb-0242ac120002.avif'
export const IOS_ADD_TO_HOME_SCREEN_IMAGE_LOCAL_PNG: string =
  '/images/f736a05e-74f6-11ed-a1eb-0242ac120002.png'
export const IOS_PRACTICAL_STREAM_AUDIO_PLAYER_MOBILE_IMAGE_AVIF: string =
  '/images/005effaa-74f7-11ed-a1eb-0242ac120002.avif'
export const IOS_PRACTICAL_STREAM_AUDIO_PLAYER_MOBILE_IMAGE_PNG: string =
  '/images/005effaa-74f7-11ed-a1eb-0242ac120002.png'
export const IMAGE_AWARD_LOCAL_PNG: string = '/images/306075.png'
export const PRACTICAL_STREAM_LOGO_LARGE_DARK_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '394ABF42-4E15-45A5-87D7-F040A457C856.jpg'
  : '/images/394ABF42-4E15-45A5-87D7-F040A457C856.jpg'
export const PRACTICAL_STREAM_LOGO_LARGE_DARK_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    'C185DA47-94DA-4853-9C08-CE7E49117902.avif?v=x'
  : '/images/C185DA47-94DA-4853-9C08-CE7E49117902.avif?v=x'
export const PRACTICAL_STREAM_LOGO_LARGE_LIGHT_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    'AA8623A9-0BCE-4057-8754-30A7CA0004D2.png?v=2'
  : '/images/AA8623A9-0BCE-4057-8754-30A7CA0004D2.png?v=2'
export const PRACTICAL_STREAM_LOGO_LARGE_LIGHT_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    'AA8623A9-0BCE-4057-8754-30A7CA0004D2.avif?v=2'
  : '/images/AA8623A9-0BCE-4057-8754-30A7CA0004D2.avif?v=2'
export const SUBSCRIPTION_EXPIRING_NOTIFICATION_THRESHOLD_DAYS: number = 30
const USE_ARWEAVE_FLAG_ICONS: boolean = false
export const FLAG_ICON_UNITED_STATES: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/A3ABDF05-C302-495D-AF81-07C5B909668F.svg'
  : ARWEAVE_GATEWAY + 'WVMxyL99tWO2rwTKnv2uBEyCGEAZ7zeD2X1PA7Tm8UE'
export const FLAG_ICON_UNITED_KINGDOM: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/982126F5-35DB-40AF-AD40-D1DB753DDC44.svg'
  : ARWEAVE_GATEWAY + 'hO9ji0GK4IGFEul5lre1bYMKuhAg4HTd6yjzWXCN8WQ'
export const FLAG_ICON_SPAIN: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/770685FB-EE9D-448D-850E-92A0AB72B93A.svg'
  : ARWEAVE_GATEWAY + '_83TNAVHzNG7lqrHMioBNGUCUew7FhfCaH-34KUoyfU'
export const FLAG_ICON_GERMANY: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/5474C935-C9FB-46C1-98D4-0CC0E6F1B390.svg'
  : ARWEAVE_GATEWAY + '89qaGV9rbHK5iNqDosnbMXxw1q67lybnu5UViJmED2s'
export const FLAG_ICON_FRANCE: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/9EB7AE7E-15F9-4500-A71C-8243F3A0141F.svg'
  : ARWEAVE_GATEWAY + 'wj3x9TkY6BxsQU5V7YtF01wSvG4AujhfWhUoWPeVrgU'
export const FLAG_ICON_AUSTRALIA: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/5B7D8DCE-6FD8-4144-BEF1-3DD4A0345F97.svg'
  : ARWEAVE_GATEWAY + 'MGAjy8lU0_E-DBRxrjIjcFwNXj0lrq1fBhrffJLpZO4'
export const FLAG_ICON_INDIA: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/5F30327B-B5C7-45DE-A3E1-8CF06AFB9A91.svg'
  : ARWEAVE_GATEWAY + 'gt18l_JK9uTGKRLfu9bP1fzCan83yoothipjsZ_OpMk'
export const FLAG_ICON_NEW_ZEALAND: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/54822057-6050-4576-ADC9-56E3D05C4D1A.svg'
  : ARWEAVE_GATEWAY + 'bagzlscvUcJwn-vzmedkClLDXQ_UfjRshfb4ZGvniKY'
export const FLAG_ICON_IRELAND: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/2171F4F2-0579-4774-8F0D-F4620F3F45FB.svg'
  : ARWEAVE_GATEWAY + 'bOlMUMhzNT90eo1RKfEXliCeMiuD8GOzFIpXNfSYzJs'
export const FLAG_ICON_CANADA: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/A0B34A74-C559-4CB3-A79E-796004FD6B0A.svg'
  : ARWEAVE_GATEWAY + 'UKoAV91Hk9twVDBzPscmuMHO81OOBRpa0z19qW4kuAI'
export const FLAG_ICON_SOUTH_AFRICA: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/D426E3D0-A8D9-4563-B28C-2E601674524F.svg'
  : ARWEAVE_GATEWAY + 'UX9yxsM4XuEHAD59TswutaZxnFCXcsBsFFuXMfFSvAc'
export const FLAG_ICON_BELGIUM: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/43238E58-E593-4626-8530-D60CD3C0C65C.svg'
  : ARWEAVE_GATEWAY + 'ZVY5CxQUDDKpC-MnzM4sSn_gS553HsC7qbVe4S4Yy34'
export const FLAG_ICON_SWITZERLAND: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/6E95A814-A1B5-49A0-8936-27E5A3826F2A.svg'
  : ARWEAVE_GATEWAY + '747NzeLlH8fH0scOTyMEClrSvFp1IfxYtJep7lEG9bc'
export const FLAG_ICON_ARGENTINA: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/58C5D3C6-6EB1-4A4F-81A3-6D93A042AC79.svg'
  : ARWEAVE_GATEWAY + 'rVgoDqjkrADS0B1FHlrAUQYlR9T2e9kb_jf0AjR7RNo'
export const FLAG_ICON_CHILE: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/EDEF9BAF-CE5D-4331-8052-30B39E1717E8.svg'
  : ARWEAVE_GATEWAY + 'HPnYIRs8Hcr0nUB1fvR_aro_Jo233_dsRD91fBkdS08'
export const FLAG_ICON_COLOMBIA: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/0E34891E-5FAE-4E04-8311-6E0C0302BCE0.svg'
  : ARWEAVE_GATEWAY + 'K9-mGaELqhj64X82IX0bitIRtUk8_OkBi2ldHTR8gl4'
export const FLAG_ICON_COSTA_RICA: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/4AA4F1E9-45DF-41A2-9F66-6642BC22AEB3.svg'
  : ARWEAVE_GATEWAY + 'nI2fTFwX2a3IsbrNujOgI9CHNXkxnFYDCPkfq5KQ4Ns'
export const FLAG_ICON_HONDURAS: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/BD7A0E07-1FB4-45A2-A6B7-E7BD86D862B1.svg'
  : ARWEAVE_GATEWAY + '33zEXAfkzdZ7K9bY_uDJkAVb-_KtWoKOyAwbbUBNN7M'
export const FLAG_ICON_MEXICO: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/859EC439-0F18-4E0C-BAF8-6EE565EB391A.svg'
  : ARWEAVE_GATEWAY + '-QT7XaLGThbBUiGk9UIVKkkbVktIWjzBh3GGyf9yWrU'
export const FLAG_ICON_PERU: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/814A5345-E3A5-4C4A-8893-59936B2D4646.svg'
  : ARWEAVE_GATEWAY + 'C80KD5WtdfotKWpzlYJFyAvf8CmfYk2_NDUifgMghQU'
export const FLAG_ICON_URUGUAY: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/E3493A8E-52E2-4C52-BEC1-2B7875D565C4.svg'
  : ARWEAVE_GATEWAY + 'Wyps3lcnIRbTdNkx5rnVrYKoio9rZgRHeSDHwdX3LgU'
export const FLAG_ICON_VENEZUELA: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/21589D25-67EE-4C4E-9864-9B216AC2590B.svg'
  : ARWEAVE_GATEWAY + 'FNkuHUTxa8vZWGXxJnq_wWi_h1MESsaYj_qE1ekWQpE'
export const FLAG_ICON_NORTH_KOREA: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/3D213E44-929A-445E-A566-F5910E839357.svg'
  : ARWEAVE_GATEWAY + '3Y0GbPNEzVVZTQHeWYDtFkd3zAzwH1vSKK_WHSZDXHQ'
export const FLAG_ICON_SOUTH_KOREA: string = !USE_ARWEAVE_FLAG_ICONS
  ? HOST + '/images/9C1C8517-919E-406D-B873-771C9B7AA0FF.svg'
  : ARWEAVE_GATEWAY + '5AXVQegdI9inGVsjSbKM5ZdYZbH4Xs5JIuHnHJRuQtk'
export const MEDIA_STREAM_PADDING_OFFSET = ' f1C  ?$   "   -տň9QJ Zχ :aYq  '
export const ANDROID_CHROME_ICON_192_X_192: string =
  '/android-chrome-192x192.png'
export const ANDROID_CHROME_ICON_256_X_256: string =
  '/android-chrome-256x256.png'
export const ANDROID_CHROME_ICON_384_X_384: string =
  '/android-chrome-384x384.png'
export const ANDROID_CHROME_ICON_512_X_512: string =
  '/android-chrome-512x512.png'
export const ANDROID_CHROME_ICON_144_X_144: string =
  '/android-chrome-144x144.png'
export const ANDROID_CHROME_ICON_128_X_128: string =
  '/android-chrome-128x128.png'
export const ANDROID_CHROME_ICON_72_X_72: string = '/android-chrome-72x72.png'
export const ANDROID_CHROME_ICON_48_X_48: string = '/android-chrome-48x48.png'
export const ANDROID_CHROME_ICON_36_X_36: string = '/android-chrome-36x36.png'
export const ANDROID_CHROME_512_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'kuW6bJ9ayVwc87uPjDw0_3-RjQKKyAJI3IU5-xVGHlY'
  : ANDROID_CHROME_ICON_512_X_512
export const ANDROID_CHROME_384_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'gTghgwAoo773Lf89wOmGCs-E_6ss5YI_8S9Wf1uW3nA'
  : ANDROID_CHROME_ICON_384_X_384
export const ANDROID_CHROME_256_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'Lo3KvBawKxgfGEbetuV_4_I_IBlD5pcDsLGQ6pcc9s0'
  : ANDROID_CHROME_ICON_256_X_256
export const ANDROID_CHROME_192_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + '6wQQvZ0z1rf_RNrJQgIqXIC2Lejx-VL8sektmkcoXAQ'
  : ANDROID_CHROME_ICON_192_X_192
export const ANDROID_CHROME_144_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'E4cNPCHVMUcKQ6Q7PdusQWXy5XaBQLVhl7V46NE78QQ'
  : ANDROID_CHROME_ICON_144_X_144
export const ANDROID_CHROME_128_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + '2uUHh0ZtjspeYvkT2TllrlaeyBwGQLWO0VtzDYbPIWo'
  : ANDROID_CHROME_ICON_128_X_128
export const ANDROID_CHROME_72_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'JhHlKNigM1xqmkYfJ18SCUWssF5_Ho0gWiImpM7gtic'
  : ANDROID_CHROME_ICON_72_X_72
export const ANDROID_CHROME_48_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + '7o7lR42JxYSHxeqI2y8ot3UgZBohwu_2JZ1dOJRlj-c'
  : ANDROID_CHROME_ICON_48_X_48
export const ANDROID_CHROME_36_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'aUwGY5HnkRgcMNh_33FSlNpeAFW4P5P8WSTE9D313wY'
  : ANDROID_CHROME_ICON_36_X_36
export const APPLE_TOUCH_180_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'SWi4-1ODaCMfWHdQ4mVxD4qO8ZhsXtEkzKmiDOq4t2k'
  : '/apple-touch-icon-180x180.png'
export const APPLE_TOUCH_152_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'jKtB3rpPD50mWwxDXTJ2KOS8TpZ0ul1KV91U394rcVg'
  : '/apple-touch-icon-152x152.png'
export const APPLE_TOUCH_144_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'dBALrteUPgOK6F1rwo8_QLckZw-8DKBb0ltJPXf12QU'
  : '/apple-touch-icon-144x144.png'
export const APPLE_TOUCH_120_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'QO8jDNb14WES66LYzvLwM_qC5evkXvSOU84TF5FdTew'
  : '/apple-touch-icon-120x120.png'
export const APPLE_TOUCH_114_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'vqRVTMw7F-x_2mHjn-7ZBDaO3_afs-bF5iWx9pPmhzY'
  : '/apple-touch-icon-114x114.png'
export const APPLE_TOUCH_76_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'KewQXYkmI0FyQk-lEdyVXMkkSesayJtF3PvWDLGu94I'
  : '/apple-touch-icon-76x76.png'
export const APPLE_TOUCH_72_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'qLjr7lq0EKby33DWUHabfpaK3A11iazH00-LsxF7xAU'
  : '/apple-touch-icon-72x72.png'
export const APPLE_TOUCH_60_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'LCXxdj6Sg0Os5uRPLZpTgsuoNSHoiS5qZ7AbztKQTtI'
  : '/apple-touch-icon-60x60.png'
export const APPLE_TOUCH_57_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'ncbkX-mpT1cnTyH8iHYpeKnMMZUL8BMHAGi249m1i8o'
  : 'apple-touch-icon-57x57.png'
export const APPLE_TOUCH_STARTUP_IMAGE_1: string =
  ARWEAVE_GATEWAY + 'j651LaY2Dm_JC6VkuJi5pgzOHjc7V0dEDjidAedqpcQ'
export const APPLE_TOUCH_STARTUP_IMAGE_2: string =
  ARWEAVE_GATEWAY + 'sXD-MiP5iGvz1GHnExAQzLupHNQLc6q92VmlyrzsxRw'
export const APPLE_TOUCH_STARTUP_IMAGE_3: string =
  ARWEAVE_GATEWAY + 'sXD-MiP5iGvz1GHnExAQzLupHNQLc6q92VmlyrzsxRw'
export const APPLE_TOUCH_STARTUP_IMAGE_4: string =
  ARWEAVE_GATEWAY + 'QmrCkpbSq9XWSPuTxyC8pn8FuUrSDg4UO78j53QXxN0'
export const APPLE_TOUCH_STARTUP_IMAGE_5: string =
  ARWEAVE_GATEWAY + 'Ji3mvJfMeWZr9m2qG8T4V6i7dVlRZherT1I2_SjDNS4'
export const APPLE_TOUCH_STARTUP_IMAGE_6: string =
  ARWEAVE_GATEWAY + '13PDCgrYGME-bGeiSDkZtf9ziMRVRIJBi-1EhmoyzMk'
export const APPLE_TOUCH_STARTUP_IMAGE_7: string =
  ARWEAVE_GATEWAY + 'BQaC8q0VSkZTsA6qp1OUJ_WDNRuT0zok8AJk94pXTlc'
export const APPLE_TOUCH_STARTUP_IMAGE_8: string =
  ARWEAVE_GATEWAY + 'luv6jvDV1Wb2zXHW5QXfVraToPJJC0EWmvOXdFoRJs4'
export const APPLE_TOUCH_STARTUP_IMAGE_9: string =
  ARWEAVE_GATEWAY + 't6caBOleawYasYYoh0TonzgzrswNWJZRsQSe4u88tO0'
export const APPLE_TOUCH_STARTUP_IMAGE_10: string =
  ARWEAVE_GATEWAY + 'eX0RmdrRmV9cMw1dTPR9nztYmkWAPodGUPEZsvS38Xc'
export const APPLE_TOUCH_STARTUP_IMAGE_11: string =
  ARWEAVE_GATEWAY + 'Vrsh2jeWSrdrTk7JFpVkWirY9fsLHoIJbxekEg26riQ'
export const APPLE_TOUCH_STARTUP_IMAGE_12: string =
  ARWEAVE_GATEWAY + 'xO-TB6i1UFxIEjSuLxfpimftAHjQdaeAwmiiA_TFvk0'
export const APPLE_TOUCH_STARTUP_IMAGE_13: string =
  ARWEAVE_GATEWAY + 'APN9gpZjcOLT6cxM8bHq3BB8ioNl4bN5x_mGXe09tFU'
export const APPLE_TOUCH_STARTUP_IMAGE_14: string =
  ARWEAVE_GATEWAY + '0V87WuZ_tNG8q8cPP6BlUWx8M_wHncxsDf9enL-dcW4'
export const APPLE_TOUCH_STARTUP_IMAGE_15: string =
  ARWEAVE_GATEWAY + 'dHd1hEZvMq7yT7vwPTEw4jj99-_3f0mqZBrQwxwAB3Q'
export const APPLE_TOUCH_STARTUP_IMAGE_16: string =
  ARWEAVE_GATEWAY + 'yw_xtehUpJCQfuTyLHfuosbwhFetvnMBBiJv_-YGz98'
export const APPLE_TOUCH_STARTUP_IMAGE_17: string =
  ARWEAVE_GATEWAY + 'e9L6ZqotHQ6rhWgcPWFyJcMTegQnthPU7WBj0KOCXM0'
export const APPLE_TOUCH_STARTUP_IMAGE_18: string =
  ARWEAVE_GATEWAY + 'MWiLSRiB-8oA5aC53ZgSck_BOSDLGWdFldDFmA8Mio4'
export const APPLE_TOUCH_STARTUP_IMAGE_19: string =
  ARWEAVE_GATEWAY + 'np5gN-IUM0bgt4nmEFScldX_Bju85nDqwtaG-8ql4TQ'
export const APPLE_TOUCH_STARTUP_IMAGE_20: string =
  ARWEAVE_GATEWAY + 'yoH38QWq4Xd9q_nmnRhmeHixn50ITRUVmBTyZyH0jyk'
export const APPLE_TOUCH_STARTUP_IMAGE_21: string =
  ARWEAVE_GATEWAY + 'D1q3ICoyrU0IWvldXSHBGSdxcD3uX14cAxrNnjRNLcI'
export const APPLE_TOUCH_STARTUP_IMAGE_22: string =
  ARWEAVE_GATEWAY + 'zaRvdHcfMLIY08fAzwxKZJcAFlwA6tCjzWVLrOImodE'
export const APPLE_TOUCH_STARTUP_IMAGE_23: string =
  ARWEAVE_GATEWAY + 'sF15h8TPkcJ8Uqk6LrYBXUsM3IxgIesw1Ta_-nqghQ4'
export const APPLE_TOUCH_STARTUP_IMAGE_24: string =
  ARWEAVE_GATEWAY + 'FbwwsYrd9YU_uRd3ENJtBY38vEYH9bKBbV45yW_31VA'
export const APPLE_TOUCH_STARTUP_IMAGE_25: string =
  ARWEAVE_GATEWAY + 'Hf6vnRk9PyE5q8GZ3ibvxyC6VfVRSuU-AhbC707M3Oo'
export const APPLE_TOUCH_STARTUP_IMAGE_26: string =
  ARWEAVE_GATEWAY + 'gRTCwZeIh7Ul2qObFfK4u5ZUwZc9w6MvR_RfsZtn56k'
export const APPLE_TOUCH_STARTUP_IMAGE_27: string =
  ARWEAVE_GATEWAY + 'qQZRPXQvYuUS-cy6qeLo7Egbvft70oBXptZgpEn1ahU'
export const APPLE_TOUCH_STARTUP_IMAGE_28: string =
  ARWEAVE_GATEWAY + 'Z-T63nkPx6gWu5kaMNKumzgWUC7YMxsOUN2QZBGtr80'
export const APPLE_TOUCH_STARTUP_IMAGE_29: string =
  ARWEAVE_GATEWAY + 'Rk211R3hnxl9Oax0er9Cbst1SASdxRJBNHz7At9YxXI'
export const APPLE_TOUCH_STARTUP_IMAGE_30: string =
  ARWEAVE_GATEWAY + 'dW-UZhg8sfJPTSPBe-9Rz1MLwuzmmELajh1CK59g4QM'
export const APPLE_TOUCH_STARTUP_IMAGE_31: string =
  ARWEAVE_GATEWAY + 'dW-UZhg8sfJPTSPBe-9Rz1MLwuzmmELajh1CK59g4QM'
export const APPLE_TOUCH_STARTUP_IMAGE_32: string =
  ARWEAVE_GATEWAY + 'EwruYMKVYoCKwjvXTSo4USO3bnU4gT32MvDuXTG-1TE'
export const APPLE_TOUCH_STARTUP_IMAGE_33: string =
  ARWEAVE_GATEWAY + 'HDNHmJO-f2BrxKH5tDzmo-Jgs08-istGnTGFUnrKxXI'
export const APPLE_TOUCH_STARTUP_IMAGE_34: string =
  ARWEAVE_GATEWAY + 'w97CS-NBPY6_4HuW4S857f4M39_-vM4IhjVnnj_05d8'
export const FAV_ICON_194: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'O4s55VvxOvdxxBXqgJ5nNK2pmziyQnfnK19Rn1BBQHs'
  : '/favicon-194x194.png'
export const FAV_ICON_96: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'Ot3SwC71CVcEiUGFrwPR1bLqZrIUfH3YCH0_ksm61Cs'
  : '/favicon-96x96.png'
export const FAV_ICON_32: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + 'M-vJo0PnH8MxUz5MiRAIWro1j7BhFcud_IMTyF9axCA'
  : '/favicon-32x32.png'
export const FAV_ICON_16: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY + '8m1Qu9gYNe8RXPH1q6fgzYmQzR0XT7CfVgb9Si_dWa8'
  : '/favicon-16x16.png'
export const FAV_ICON_CDN_OR_LOCAL: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'favicon.ico'
  : '/favicon.ico'
export const SVG_ICON_CDN_OR_LOCAL: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'icon.svg'
  : '/icon.svg'
export const MS_TILE_144_CDN_OR_LOCAL: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'mstile-144x144.png'
  : '/mstile-144x144.png'
export const SAFARI_PINNED_TAB_CDN_OR_LOCAL: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'safari-pinned-tab.svg'
  : '/safari-pinned-tab.svg'
export const FAV_ICON_194_X_194: string = '/favicon-194x194.png'
export const FAV_ICON_96_X_96: string = '/favicon-96x96.png'
export const FAV_ICON_36_X_36: string = '/favicon-32x32.png'
export const FAV_ICON_16_X_16: string = '/favicon-16x16.png'
export const THEME_COLOR: string = SYSTEM_BLACK_COLOR
export const MS_APP_TILE_COLOR: string = SYSTEM_BLACK_COLOR
export const SAFARI_PINNED_TAB_MASK_ICON_COLOR: string = SYSTEM_BLACK_COLOR

export const RETURNS_POLICY_DAYS_WINDOW: string = '7'

export const USE_ALL_ENVIRONMENTS_FOR_UCP: boolean = true

export const UCP_LOGO: string =
  HOST + '/images/0402550A-C89C-4699-A4C4-D17DCEAE5A4C.png'

export const PRESET_SAMPLE_ENDED: string =
  '53D95E40-638A-4A75-AE69-B9FCDDAD22DB.wav'
export const PRESET_SAMPLE_PARTY: string =
  '30ADD1BE-FF58-4791-9CC0-5B37BEF40D0F.wav'
export const PRESET_SAMPLE_CHILL: string =
  '488ED916-A859-44C9-B7C4-DADF80BCD830.wav'
export const PRESET_SAMPLE_LUXURY: string =
  '1BA977E1-4FD6-446F-90C0-2557069E9984.wav'
export const PRESET_SAMPLE_BAR: string =
  'ACF97C2A-A199-4DE2-A57A-D7ADBB9AA348.wav'
export const PRESET_SAMPLE_CAFE: string =
  '08B961CF-8627-46D9-B7E8-44BC7C70A83F.wav'
export const PRESET_SAMPLE_PUMP: string =
  'E67E7173-163C-4B6C-8C20-C59EFB9FEA3E.wav'
export const PRESET_SAMPLE_SHOP: string =
  '7FBBC5CA-69E1-4C71-AD9C-2E0762E1EBCE.wav'
export const PRESET_SAMPLE_SPAS: string =
  '72AC14B3-2AC7-4653-9C16-FDBCE4CBCB53.wav'
export const AVATAR_BACKGROUND_IMAGE_LIGHT_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'de07683c-4f14-11ed-bdc3-0242ac120002.avif'
  : '/images/de07683c-4f14-11ed-bdc3-0242ac120002.avif'
export const AVATAR_BACKGROUND_IMAGE_LIGHT_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'de07683c-4f14-11ed-bdc3-0242ac120002.png'
  : '/images/de07683c-4f14-11ed-bdc3-0242ac120002.png'
export const AVATAR_BACKGROUND_IMAGE_DARK_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '18c57588-4f13-11ed-bdc3-0242ac120002.avif'
  : '/images/18c57588-4f13-11ed-bdc3-0242ac120002.avif'
export const AVATAR_BACKGROUND_IMAGE_DARK_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '18c57588-4f13-11ed-bdc3-0242ac120002.png'
  : '/images/18c57588-4f13-11ed-bdc3-0242ac120002.png'
export const PRICING_GRID_LOGO_LIGHT_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '67A3A8E9-19A2-4DA8-A6A3-B8128F14AA51.avif'
  : '/images/67A3A8E9-19A2-4DA8-A6A3-B8128F14AA51.avif'
export const PRICING_GRID_LOGO_LIGHT_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '67A3A8E9-19A2-4DA8-A6A3-B8128F14AA51.png?f=4'
  : '/images/67A3A8E9-19A2-4DA8-A6A3-B8128F14AA51.png?f=4'
export const PRICING_GRID_LOGO_DARK_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '13EC7658-11C2-4607-92B6-868C6BEE6F6A.avif?f=g'
  : '/images/13EC7658-11C2-4607-92B6-868C6BEE6F6A.avif?f=g'
export const PRICING_GRID_LOGO_DARK_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '13EC7658-11C2-4607-92B6-868C6BEE6F6A.png'
  : '/images/13EC7658-11C2-4607-92B6-868C6BEE6F6A.png'
export const HERO_HEADER_LOGO: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '13EC7658-11C2-4607-92B6-868C6BEE6F6A.png?m=5'
  : '/images/13EC7658-11C2-4607-92B6-868C6BEE6F6A.png?m=5'
export const HERO_HEADER_LOGO_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '13EC7658-11C2-4607-92B6-868C6BEE6F6A.avif?f=5'
  : '/images/13EC7658-11C2-4607-92B6-868C6BEE6F6A.avif?f=5'
export const HERO_PAGE_BACKGROUND_RESTAURANTS_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'B83A9464-4ECE-4E58-B624-DB9ED4328871.png'
export const HERO_PAGE_BACKGROUND_RESTAURANTS: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_RESTAURANTS_CDN
  : '/images/B83A9464-4ECE-4E58-B624-DB9ED4328871.png'
export const HERO_PAGE_BACKGROUND_RESTAURANTS_CDN_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'B83A9464-4ECE-4E58-B624-DB9ED4328871.avif'
export const HERO_PAGE_BACKGROUND_RESTAURANTS_AVIF: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_RESTAURANTS_CDN_AVIF
  : '/images/B83A9464-4ECE-4E58-B624-DB9ED4328871.avif'
export const HERO_PAGE_BACKGROUND_BARS_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '5BA9485C-6CE6-4CAC-86BE-345FE4A86DE9.png'
export const HERO_PAGE_BACKGROUND_BARS: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_BARS_CDN
  : '/images/5BA9485C-6CE6-4CAC-86BE-345FE4A86DE9.png'
export const HERO_PAGE_BACKGROUND_BARS_CDN_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '5BA9485C-6CE6-4CAC-86BE-345FE4A86DE9.avif'
export const HERO_PAGE_BACKGROUND_BARS_AVIF: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_BARS_CDN_AVIF
  : '/images/5BA9485C-6CE6-4CAC-86BE-345FE4A86DE9.avif'
export const HERO_PAGE_BACKGROUND_SHOPS_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '5B23C5EA-2761-4308-85A7-2078AC76CB03.png'
export const HERO_PAGE_BACKGROUND_SHOPS: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_SHOPS_CDN
  : '/images/5B23C5EA-2761-4308-85A7-2078AC76CB03.png'
export const HERO_PAGE_BACKGROUND_SHOPS_CDN_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '5B23C5EA-2761-4308-85A7-2078AC76CB03.avif'
export const HERO_PAGE_BACKGROUND_SHOPS_AVIF: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_SHOPS_CDN_AVIF
  : '/images/5B23C5EA-2761-4308-85A7-2078AC76CB03.avif'
export const HERO_PAGE_BACKGROUND_GYMS_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '88DE0E89-CFC8-4672-803C-0E6303D7E5AC.png'
export const HERO_PAGE_BACKGROUND_GYMS: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_GYMS_CDN
  : '/images/88DE0E89-CFC8-4672-803C-0E6303D7E5AC.png'
export const HERO_PAGE_BACKGROUND_GYMS_CDN_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '88DE0E89-CFC8-4672-803C-0E6303D7E5AC.avif'
export const HERO_PAGE_BACKGROUND_GYMS_AVIF: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_GYMS_CDN_AVIF
  : '/images/88DE0E89-CFC8-4672-803C-0E6303D7E5AC.avif'
export const HERO_PAGE_BACKGROUND_IMAGE_NIGHTCLUBS_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'A3D45A1C-D771-47AD-972A-794BD85384F9.png'
export const HERO_PAGE_BACKGROUND_NIGHTCLUBS: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_IMAGE_NIGHTCLUBS_CDN
  : '/images/A3D45A1C-D771-47AD-972A-794BD85384F9.png'
export const HERO_PAGE_BACKGROUND_IMAGE_NIGHTCLUBS_CDN_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'A3D45A1C-D771-47AD-972A-794BD85384F9.avif'
export const HERO_PAGE_BACKGROUND_NIGHTCLUBS_AVIF: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_IMAGE_NIGHTCLUBS_CDN_AVIF
  : '/images/A3D45A1C-D771-47AD-972A-794BD85384F9.avif'
export const HERO_PAGE_BACKGROUND_LUXURY_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '4679BCB4-7967-47ED-88FF-182F44E6C740.png'
export const HERO_PAGE_BACKGROUND_LUXURY: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_LUXURY_CDN
  : '/images/4679BCB4-7967-47ED-88FF-182F44E6C740.png'
export const HERO_PAGE_BACKGROUND_LUXURY_CDN_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '4679BCB4-7967-47ED-88FF-182F44E6C740.avif'
export const HERO_PAGE_BACKGROUND_LUXURY_AVIF: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_LUXURY_CDN_AVIF
  : '/images/4679BCB4-7967-47ED-88FF-182F44E6C740.avif'
export const HERO_PAGE_BACKGROUND_IMAGE_SPAS_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'D12694D7-5EDB-4F57-A5AB-C851224B7469.png'
export const HERO_PAGE_BACKGROUND_SPAS: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_IMAGE_SPAS_CDN
  : '/images/D12694D7-5EDB-4F57-A5AB-C851224B7469.png'
export const HERO_PAGE_BACKGROUND_IMAGE_SPAS_CDN_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'D12694D7-5EDB-4F57-A5AB-C851224B7469.avif'
export const HERO_PAGE_BACKGROUND_SPAS_AVIF: string = USE_CDN
  ? HERO_PAGE_BACKGROUND_IMAGE_SPAS_CDN_AVIF
  : '/images/D12694D7-5EDB-4F57-A5AB-C851224B7469.avif'
export const HERO_PAGE_WELLNESS_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'F9D1DD7B-BD02-4AFE-918D-549E868C298E.png'
export const HERO_PAGE_BACKGROUND_WELLNESS: string = USE_CDN
  ? HERO_PAGE_WELLNESS_CDN
  : '/images/F9D1DD7B-BD02-4AFE-918D-549E868C298E.png'
export const HERO_PAGE_WELLNESS_CDN_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'F9D1DD7B-BD02-4AFE-918D-549E868C298E.avif'
export const HERO_PAGE_BACKGROUND_WELLNESS_AVIF: string = USE_CDN
  ? HERO_PAGE_WELLNESS_CDN_AVIF
  : '/images/F9D1DD7B-BD02-4AFE-918D-549E868C298E.avif'
export const LOGO_LARGE_DARK_AVIF_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '9CD7D49A-42AC-4D1D-97BA-A08A8F31ADDB.avif?v=2'
  : '/images/9CD7D49A-42AC-4D1D-97BA-A08A8F31ADDB.avif?v=2'
export const LOGO_LARGE_LIGHT_AVIF_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '0DFBA122-3499-42FE-A83A-27AD364EDD79.avif?v=2'
  : '/images/0DFBA122-3499-42FE-A83A-27AD364EDD79.avif?v=2'
export const LOGO_SMALL_DARK_AVIF_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '48EFD03D-C38C-48DA-BECB-B9DAACFFB042.avif?v=2'
  : '/images/48EFD03D-C38C-48DA-BECB-B9DAACFFB042.avif?v=2'
export const LOGO_SMALL_LIGHT_AVIF_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '2EB3D48E-4496-4502-A32C-8523EBF964D7.avif?v=2'
  : '/images/2EB3D48E-4496-4502-A32C-8523EBF964D7.avif?v=2'
export const LOGO_LARGE_DARK_PNG_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '9CD7D49A-42AC-4D1D-97BA-A08A8F31ADDB.png?v=2'
  : '/images/9CD7D49A-42AC-4D1D-97BA-A08A8F31ADDB.png?v=2'
export const LOGO_LARGE_LIGHT_PNG_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '0DFBA122-3499-42FE-A83A-27AD364EDD79.png?v=2'
  : '/images/0DFBA122-3499-42FE-A83A-27AD364EDD79.png?v=2'
export const LOGO_SMALL_DARK_PNG_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '48EFD03D-C38C-48DA-BECB-B9DAACFFB042.png?v=2'
  : '/images/48EFD03D-C38C-48DA-BECB-B9DAACFFB042.png?v=2'
export const LOGO_SMALL_LIGHT_PNG_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '05692232-16A8-4658-9F0B-3D7C1ED4E054.png?v=1'
  : '/images/05692232-16A8-4658-9F0B-3D7C1ED4E054.png?v=1'
export const SMALL_LOGO_DARK_AVIF_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '14FADFBA-7E70-4342-B511-073A28FD4B22.avif?v=1'
  : '/images/14FADFBA-7E70-4342-B511-073A28FD4B22.avif?v=1'
export const SMALL_LOGO_DARK_PNG_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '14FADFBA-7E70-4342-B511-073A28FD4B22.png?v=1'
  : '/images/14FADFBA-7E70-4342-B511-073A28FD4B22.png?v=1'
export const SMALL_LOGO_LIGHT_AVIF_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '05692232-16A8-4658-9F0B-3D7C1ED4E054.avif?v=1'
  : '/images/05692232-16A8-4658-9F0B-3D7C1ED4E054.avif?v=1'
export const JSON_LD_PRODUCT_LOGO_1500_X_1500_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'C83A64B7-190C-48FE-9583-60D437A92251.png'
  : HOST + '/images/C83A64B7-190C-48FE-9583-60D437A92251.png'
export const JSON_LD_PRODUCT_LOGO_1500_X_1500_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'C83A64B7-190C-48FE-9583-60D437A92251.avif'
  : HOST + '/images/C83A64B7-190C-48FE-9583-60D437A92251.avif'
export const JSON_LD_PRODUCT_ICON_OF_GENERIC_PROVIDER_1500_X_1500_AVIF: string =
  USE_CDN
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'CCF014A1-EBB7-4959-854E-7740926BA3B0.avif'
    : HOST + '/images/CCF014A1-EBB7-4959-854E-7740926BA3B0.avif'
export const JSON_LD_PRODUCT_ICON_OF_GENERIC_PROVIDER_1500_X_1500_PNG: string =
  USE_CDN
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'CCF014A1-EBB7-4959-854E-7740926BA3B0.png'
    : HOST + '/images/CCF014A1-EBB7-4959-854E-7740926BA3B0.png'
export const SMALL_LOGO_LIGHT_PNG_CDN: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '4CD0DE6A-5EAD-4FC1-B7F8-F01DADE044B7.png'
  : '/images/4CD0DE6A-5EAD-4FC1-B7F8-F01DADE044B7.png'
export const PRACTICAL_POD_HOME_IMAGE_ZOOM_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '630C3631-3C1A-4F11-AB86-A9203506D496.avif'
  : '/images/630C3631-3C1A-4F11-AB86-A9203506D496.avif'
export const PRACTICAL_POD_HOME_IMAGE_ZOOM_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '630C3631-3C1A-4F11-AB86-A9203506D496.png'
  : '/images/630C3631-3C1A-4F11-AB86-A9203506D496.png'
export const PRACTICAL_POD_HOME_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'CDAE9703-7488-4348-9420-ABE3913C82B6.avif'
  : '/images/CDAE9703-7488-4348-9420-ABE3913C82B6.avif'
export const PRACTICAL_POD_HOME_IMAGE_CDN_PNG: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'CDAE9703-7488-4348-9420-ABE3913C82B6.png'
export const PRACTICAL_POD_HOME_IMAGE_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'CDAE9703-7488-4348-9420-ABE3913C82B6.png'
  : '/images/CDAE9703-7488-4348-9420-ABE3913C82B6.png'
export const PRACTICAL_POD_HOME_IMAGE_ZOOM_AVIF_UNZOOMED: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'A358C70B-FFE3-4508-804E-A4C6A004BFC7.avif'
  : '/images/A358C70B-FFE3-4508-804E-A4C6A004BFC7.avif'
export const PRACTICAL_POD_HOME_IMAGE_ZOOM_PNG_UNZOOMED: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'A358C70B-FFE3-4508-804E-A4C6A004BFC7.png'
  : '/images/A358C70B-FFE3-4508-804E-A4C6A004BFC7.png'
export const DEVICE_PAGE_STRIPE_LOGO: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '3B68E06F-2068-44F9-9C3C-D2870B6E8600.png'
  : '/images/3B68E06F-2068-44F9-9C3C-D2870B6E8600.png'
export const DEVICE_PAGE_STRIPE_LOGO_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '3B68E06F-2068-44F9-9C3C-D2870B6E8600.avif'
  : '/images/3B68E06F-2068-44F9-9C3C-D2870B6E8600.avif'
export const DEVICE_PAGE_AND_LLMS_TXT_DEVICE_PIC: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '28A4DFA3-0109-4273-8F28-C9940A88ED1A.png'
  : '/images/28A4DFA3-0109-4273-8F28-C9940A88ED1A.png'
export const DISCOUNT_MUSIC_AVIF_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '05D0DDFF-0AB2-41C5-99CD-7B92F8123998.avif'
export const SAVE_MONEY_AVIF_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '269D2617-3C9E-4C34-B05B-444F98DFDC4D.avif'
export const PEACE_OF_MIND_AVIF_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '58B03FC9-0824-4A23-8FF6-F0D889EE1A05.avif'
export const STREAM_TODAY_AVIF_CDN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + '105715CC-948D-4AFC-BF3D-277EF9CE2665.avif'
export const DISCOUNT_MUSIC_IMG_SRC_AVIF_LOCAL: string =
  '/images/05D0DDFF-0AB2-41C5-99CD-7B92F8123998.avif'
export const DISCOUNT_MUSIC_IMG_SRC_JPEG_LOCAL: string =
  '/images/05D0DDFF-0AB2-41C5-99CD-7B92F8123998.jpg'
export const SAVE_MONEY_IMG_SRC_AVIF_LOCAL: string =
  '/images/269D2617-3C9E-4C34-B05B-444F98DFDC4D.avif'
export const SAVE_MONEY_IMG_SRC_JPEG_LOCAL: string =
  '/images/269D2617-3C9E-4C34-B05B-444F98DFDC4D.jpg'
export const PEACE_OF_MIND_IMG_SRC_AVIF_LOCAL: string =
  '/images/58B03FC9-0824-4A23-8FF6-F0D889EE1A05.avif'
export const PEACE_OF_MIND_IMG_SRC_JPEG_LOCAL: string =
  '/images/58B03FC9-0824-4A23-8FF6-F0D889EE1A05.jpeg'
export const STREAM_TODAY_IMG_SRC_AVIF_LOCAL: string =
  '/images/105715CC-948D-4AFC-BF3D-277EF9CE2665.avif'
export const STREAM_TODAY_IMG_SRC_JPEG_LOCAL: string =
  '/images/105715CC-948D-4AFC-BF3D-277EF9CE2665.jpg'
export const PRESET_IMAGE_LUXURY_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'A5581781-6DDC-4D71-89E5-987A87B722D7.avif'
  : '/images/A5581781-6DDC-4D71-89E5-987A87B722D7.avif'
export const PRESET_IMAGE_LUXURY_JPG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'A5581781-6DDC-4D71-89E5-987A87B722D7.jpeg'
  : '/images/A5581781-6DDC-4D71-89E5-987A87B722D7.jpeg'
export const PRESET_IMAGE_GYM_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '80F844A6-A072-45CB-95AF-F9871406BBC5.avif'
  : '/images/80F844A6-A072-45CB-95AF-F9871406BBC5.avif'
export const PRESET_IMAGE_GYM_JPG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '80F844A6-A072-45CB-95AF-F9871406BBC5.jpeg'
  : '/images/80F844A6-A072-45CB-95AF-F9871406BBC5.jpeg'
export const PRESET_IMAGE_CHILL_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '014D3ABA-AE4D-4243-AAB7-1596D0538F34.avif'
  : '/images/014D3ABA-AE4D-4243-AAB7-1596D0538F34.avif'
export const PRESET_IMAGE_CHILL_JPG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '014D3ABA-AE4D-4243-AAB7-1596D0538F34.jpeg'
  : '/images/014D3ABA-AE4D-4243-AAB7-1596D0538F34.jpeg'
export const PRESET_IMAGE_SHOP_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '806A810B-B8A2-4606-8A5C-B7740288EB8F.avif'
  : '/images/806A810B-B8A2-4606-8A5C-B7740288EB8F.avif'
export const PRESET_IMAGE_SHOP_JPG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '806A810B-B8A2-4606-8A5C-B7740288EB8F.jpeg'
  : '/images/806A810B-B8A2-4606-8A5C-B7740288EB8F.jpeg'
export const PRESET_IMAGE_PARTY_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '9C56E10C-6157-43D2-8719-AB34A12CAEC3.avif'
  : '/images/9C56E10C-6157-43D2-8719-AB34A12CAEC3.avif'
export const PRESET_IMAGE_PARTY_JPG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '9C56E10C-6157-43D2-8719-AB34A12CAEC3.jpeg'
  : '/images/9C56E10C-6157-43D2-8719-AB34A12CAEC3.jpeg'
export const PRESET_IMAGE_SPA_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '410A2B0E-80C1-430E-B445-34CE0E18679F.avif'
  : '/images/410A2B0E-80C1-430E-B445-34CE0E18679F.avif'
export const PRESET_IMAGE_SPA_JPG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '410A2B0E-80C1-430E-B445-34CE0E18679F.jpeg'
  : '/images/410A2B0E-80C1-430E-B445-34CE0E18679F.jpeg'
export const PRESET_IMAGE_CAFE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '89A8455B-AD70-4170-928D-0173F3E64130.avif'
  : '/images/89A8455B-AD70-4170-928D-0173F3E64130.avif'
export const PRESET_IMAGE_CAFE_JPG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '89A8455B-AD70-4170-928D-0173F3E64130.jpeg'
  : '/images/89A8455B-AD70-4170-928D-0173F3E64130.jpeg'
export const PRESET_IMAGE_BAR_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '171B9F01-C92B-4449-9EE0-A920F2E23A04.avif'
  : '/images/171B9F01-C92B-4449-9EE0-A920F2E23A04.avif'
export const PRESET_IMAGE_BAR_JPG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '171B9F01-C92B-4449-9EE0-A920F2E23A04.jpg'
  : '/images/171B9F01-C92B-4449-9EE0-A920F2E23A04.jpg'
export const MUSIC_ICON_HOMEPAGE_DARK_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'C9654028-C6FA-4115-9047-D8F89E1881B4.png'
  : '/images/C9654028-C6FA-4115-9047-D8F89E1881B4.png'
export const MUSIC_ICON_HOMEPAGE_DARK_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'C9654028-C6FA-4115-9047-D8F89E1881B4.avif'
  : '/images/C9654028-C6FA-4115-9047-D8F89E1881B4.avif'
export const MUSIC_ICON_HOMEPAGE_LIGHT_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '0F2DA96A-BC2D-4A97-882E-1E709EF41D9E.png'
  : '/images/0F2DA96A-BC2D-4A97-882E-1E709EF41D9E.png'
export const MUSIC_ICON_HOMEPAGE_LIGHT_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '0F2DA96A-BC2D-4A97-882E-1E709EF41D9E.avif'
  : '/images/0F2DA96A-BC2D-4A97-882E-1E709EF41D9E.avif'
export const ONE_HUNDRED_ICON_HOMEPAGE_DARK_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '309B57F7-AEDB-42BC-8FE5-1AAD4574F7C8.avif'
  : '/images/309B57F7-AEDB-42BC-8FE5-1AAD4574F7C8.avif'
export const ONE_HUNDRED_ICON_HOMEPAGE_DARK_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '309B57F7-AEDB-42BC-8FE5-1AAD4574F7C8.png'
  : '/images/309B57F7-AEDB-42BC-8FE5-1AAD4574F7C8.png'
export const ONE_HUNDRED_ICON_HOMEPAGE_LIGHT_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '33B54D3E-3FB5-441C-AA73-6BF849E6CE8D.avif'
  : '/images/33B54D3E-3FB5-441C-AA73-6BF849E6CE8D.avif'
export const ONE_HUNDRED_ICON_HOMEPAGE_LIGHT_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '33B54D3E-3FB5-441C-AA73-6BF849E6CE8D.png'
  : '/images/33B54D3E-3FB5-441C-AA73-6BF849E6CE8D.png'
export const DOLLAR_SYMBOL_ICON_HOMEPAGE_DARK_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '545BC223-E4A0-426D-81D0-85E8B133AC1D.avif'
  : '/images/545BC223-E4A0-426D-81D0-85E8B133AC1D.avif'
export const DOLLAR_SYMBOL_ICON_HOMEPAGE_DARK_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '545BC223-E4A0-426D-81D0-85E8B133AC1D.png'
  : '/images/545BC223-E4A0-426D-81D0-85E8B133AC1D.png'
export const DOLLAR_SYMBOL_ICON_HOMEPAGE_LIGHT_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '8B8C590E-DD9A-45DE-A484-202F3B9E0FCE.avif'
  : '/images/8B8C590E-DD9A-45DE-A484-202F3B9E0FCE.avif'
export const DOLLAR_SYMBOL_ICON_HOMEPAGE_LIGHT_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '8B8C590E-DD9A-45DE-A484-202F3B9E0FCE.png'
  : '/images/8B8C590E-DD9A-45DE-A484-202F3B9E0FCE.png'
export const SIXTY_PERCENT_ICON_HOMEPAGE_DARK_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '3D12200B-0FAB-4C33-833E-068CDC723F19.avif'
  : '/images/3D12200B-0FAB-4C33-833E-068CDC723F19.avif'
export const SIXTY_PERCENT_ICON_HOMEPAGE_DARK_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '3D12200B-0FAB-4C33-833E-068CDC723F19.png'
  : '/images/3D12200B-0FAB-4C33-833E-068CDC723F19.png'
export const SIXTY_PERCENT_ICON_HOMEPAGE_LIGHT_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '606DDC55-BE2D-49CA-BF9A-91436C979C5B.avif'
  : '/images/606DDC55-BE2D-49CA-BF9A-91436C979C5B.avif'
export const SIXTY_PERCENT_ICON_HOMEPAGE_LIGHT_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '606DDC55-BE2D-49CA-BF9A-91436C979C5B.png'
  : '/images/606DDC55-BE2D-49CA-BF9A-91436C979C5B.png'
export const DEVICES_ICON_HOMEPAGE_DARK_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '89221CAD-0925-4D84-A90C-E08B3CFEAFFB.avif'
  : '/images/89221CAD-0925-4D84-A90C-E08B3CFEAFFB.avif'
export const DEVICES_ICON_HOMEPAGE_DARK_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '89221CAD-0925-4D84-A90C-E08B3CFEAFFB.png'
  : '/images/89221CAD-0925-4D84-A90C-E08B3CFEAFFB.png'
export const DEVICES_ICON_HOMEPAGE_LIGHT_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    'BA1900B9-B21A-4D38-BDD4-75613DCE4493.avif'
  : '/images/BA1900B9-B21A-4D38-BDD4-75613DCE4493.avif'
export const DEVICES_ICON_HOMEPAGE_LIGHT_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    'BA1900B9-B21A-4D38-BDD4-75613DCE4493.png'
  : '/images/BA1900B9-B21A-4D38-BDD4-75613DCE4493.png'
export const ART_SPLASH_ICON_HOMEPAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '0056B6CA-C32F-4C6A-9908-423121A47FAE.avif'
  : '/images/0056B6CA-C32F-4C6A-9908-423121A47FAE.avif'
export const ART_SPLASH_ICON_HOMEPAGE_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '0056B6CA-C32F-4C6A-9908-423121A47FAE.png'
  : '/images/0056B6CA-C32F-4C6A-9908-423121A47FAE.png'
export const COUCH_HOMEPAGE_JPG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    'D1616F25-ACDC-4313-827D-B7E8DB0A6D9D.jpg'
  : '/images/D1616F25-ACDC-4313-827D-B7E8DB0A6D9D.jpg'
export const COUCH_HOMEPAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    'D1616F25-ACDC-4313-827D-B7E8DB0A6D9D.avif'
  : '/images/D1616F25-ACDC-4313-827D-B7E8DB0A6D9D.avif'
export const COUCH_HOMEPAGE_SMALL_SQUARE_JPG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    'F55101D7-159B-4E9B-A2F0-8FC177D6B397.jpg'
  : '/images/F55101D7-159B-4E9B-A2F0-8FC177D6B397.jpg'
export const COUCH_HOMEPAGE_SMALL_SQUARE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    'F55101D7-159B-4E9B-A2F0-8FC177D6B397.avif'
  : '/images/F55101D7-159B-4E9B-A2F0-8FC177D6B397.avif'
export const MONITOR_ICON_HOMEPAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '50AE52A9-5789-4FCC-8FC8-A684CF248E20.avif'
  : '/images/50AE52A9-5789-4FCC-8FC8-A684CF248E20.avif'
export const MONITOR_ICON_HOMEPAGE_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    CDN_PERM_CACHE_FOLDER +
    '50AE52A9-5789-4FCC-8FC8-A684CF248E20.png'
  : '/images/50AE52A9-5789-4FCC-8FC8-A684CF248E20.png'
export const CROWD_HOMEPAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '65047B96-FD9C-4ED8-A852-FA2E872F8CF0.avif'
  : '/images/65047B96-FD9C-4ED8-A852-FA2E872F8CF0.avif'
export const CROWD_HOMEPAGE_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '65047B96-FD9C-4ED8-A852-FA2E872F8CF0.png'
  : '/images/65047B96-FD9C-4ED8-A852-FA2E872F8CF0.png'
export const CONTRACT_ICON_HOMEPAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '4BB4F82C-251E-439B-9F5B-974CF85B5A1E.avif'
  : '/images/4BB4F82C-251E-439B-9F5B-974CF85B5A1E.avif'
export const CONTRACT_ICON_HOMEPAGE_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '4BB4F82C-251E-439B-9F5B-974CF85B5A1E.png'
  : '/images/4BB4F82C-251E-439B-9F5B-974CF85B5A1E.png'
export const PHONE_HEADSET_HOMEPAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'E09A367B-FA9E-4BC0-B60D-8CECADDD686C.avif'
  : '/images/E09A367B-FA9E-4BC0-B60D-8CECADDD686C.avif'
export const PHONE_HEADSET_HOMEPAGE_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'E09A367B-FA9E-4BC0-B60D-8CECADDD686C.png'
  : '/images/E09A367B-FA9E-4BC0-B60D-8CECADDD686C.png'
export const CLIPBOARD_ICON_HOMEPAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'E950C3B4-28E3-4903-9BCF-1A87E6453E22.avif'
  : '/images/E950C3B4-28E3-4903-9BCF-1A87E6453E22.avif'
export const CLIPBOARD_ICON_HOMEPAGE_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'E950C3B4-28E3-4903-9BCF-1A87E6453E22.png'
  : '/images/E950C3B4-28E3-4903-9BCF-1A87E6453E22.png'
export const LOCATION_ICON_HOMEPAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'B6D5F7BC-EBF2-4505-BC85-858291C3D581.avif'
  : '/images/B6D5F7BC-EBF2-4505-BC85-858291C3D581.avif'
export const LOCATION_ICON_HOMEPAGE_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'B6D5F7BC-EBF2-4505-BC85-858291C3D581.png'
  : '/images/B6D5F7BC-EBF2-4505-BC85-858291C3D581.png'
export const SPEAKERPHONE_ICON_HOMEPAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '2801524A-06D9-4E08-A113-B9409523586A.avif'
  : '/images/2801524A-06D9-4E08-A113-B9409523586A.avif'
export const SPEAKERPHONE_ICON_HOMEPAGE_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '2801524A-06D9-4E08-A113-B9409523586A.png'
  : '/images/2801524A-06D9-4E08-A113-B9409523586A.png'
export const TAILWIND_SCRIPT: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'tw.min.js'
export const NODE_CRYPTO_ALGORITHM: string = 'aes-256-ctr'
export const NODE_CRYPTO_PASSWORD: string = 'a77bbcc6'
export const GOOGLE_ANALYTICS_MEASUREMENT_ID: string = 'G-CSY4JPXZWT'
export const GOOGLE_ANALYTICS_STREAM_ID: string = '11359856874'
export const USE_GOOGLE_ANALYTICS: boolean = true
export const GOOGLE_ANALYTICS_TAG: string = 'AW-17143498120'
export const GOOGLE_ANALYTICS_SCRIPT: string = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${GOOGLE_ANALYTICS_TAG}', { 'debug_mode':true });`
export const GOOGLE_ANALYTICS_PURCHASE_EVENT_ITEM_NAME_HARDWARE: string =
  'Hardware Subscription'
export const GOOGLE_ANALYTICS_PURCHASE_EVENT_ITEM_NAME: string =
  'Software Subscription'
export const USE_GOOGLE_TAG_MANAGER: boolean = true
export const GOOGLE_TAG_MANAGER_ID: string = 'GTM-MBBPPFR7'
export const STREAMY3_INFORMAL_BUSINESS_NAME: string = 'Practical Stream'
export const STREAMY3_OFFICIAL_BUSINESS_NAME: string = 'Streamy3, LLC'
export const STREAMY3_OFFICIAL_ADDRESS_LINE_1: string =
  '5830 E 2nd St., Ste 7000'
export const STREAMY3_OFFICIAL_ADDRESS_LINE_2: string = '#14870'
export const STREAMY3_OFFICIAL_ADDRESS_CITY: string = 'Casper'
export const STREAMY3_OFFICIAL_ADDRESS_STATE_CODE: string = 'WY'
export const STREAMY3_OFFICIAL_ADDRESS_ZIP_CODE: string = '82609'
export const STREAMY3_OFFICIAL_ADDRESS_COUNTRY: string = 'United States'
export const STREAMY3_NAICS_MEDIA_STREAMING_DISTRIBUTION: string = '516210'
export const STREAMY3_NAICS_COMPUTER_SYSTEMS_DESIGN: string = '541512'
export const STREAMY3_NAICS_COMPUTING_INFRASTRUCTURE_PROVIDERS: string =
  '518210'
export const STREAMY3_NAICS_SOFTWARE_PUBLISHERS: string = '513210'
export const STREAMY3_ALL_NAICS_FOR_JSON_LD: string = `"${STREAMY3_NAICS_MEDIA_STREAMING_DISTRIBUTION}",
                                                         "${STREAMY3_NAICS_COMPUTER_SYSTEMS_DESIGN}",
                                                         "${STREAMY3_NAICS_COMPUTING_INFRASTRUCTURE_PROVIDERS}",
                                                         "${STREAMY3_NAICS_SOFTWARE_PUBLISHERS}"`
export const USE_CHATBOT: boolean = true
export const EU_MEMBER_STATES_ISO_CODES: string[] = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
]
export const ROUTE_CODE_HOME: number = 0
export const ROUTE_CODE_SETTINGS: number = -1
export const ROUTE_CODE_SEARCH: number = 1
export const ROUTE_CODE_STUDIO: number = 2
export const ROUTE_CODE_PLAYLIST: number = 3
export const ROUTE_CODE_FAVORITES: number = 4
export const ROUTE_CODE_CONTACT: number = 5
export const PATH_HOME_EN: string = '/home'
export const PATH_HOME_FR: string = '/ecouter'
export const PATH_HOME_ES: string = '/hogar'
export const PATH_HOME_KO: string = '/듣다'
export const PATH_SEARCH_EN: string = '/search'
export const PATH_SEARCH_FR: string = '/trouve'
export const PATH_SEARCH_ES: string = '/buscar'
export const PATH_SEARCH_KO: string = '/찾기'
export const PATH_STUDIO_EN: string = '/studio'
export const PATH_STUDIO_FR: string = '/studio'
export const PATH_STUDIO_ES: string = '/estudio'
export const PATH_STUDIO_KO: string = '/스튜디오'
export const PATH_PLAYLIST_KO: string = '/플레이리스트'
export const PATH_PLAYLIST_EN_ES_FR: string = '/playlist'
export const PATH_FAVORITES_EN: string = '/favorites'
export const PATH_FAVORITES_FR: string = '/favoris'
export const PATH_FAVORITES_ES: string = '/favoritos'
export const PATH_FAVORITES_KO: string = '/좋아요'
export const PATH_SETTINGS_EN_ES_FR_KO: string = '/account-settings'
export const PATH_SETTINGS_EN_ES_FR_KO_BRIEF: string = '/settings'
export const PATH_CONTACT_EN_FR: string = '/contact'
export const PATH_CONTACT_ES: string = '/contacto'
export const PATH_CONTACT_KO: string = '/문의하기'
export const EVALUATE_INVITATION_DELAY: number = 1500
export const CHECK_USERS_AND_INVITATIONS_FREQUENCY_SECONDS: number = 120
const USE_CDN_FOR_AUDIO_SILENT_SRC: boolean = true
export const AUDIO_SILENT_SRC: string = USE_CDN_FOR_AUDIO_SILENT_SRC
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    'a/' +
    'X-dmGLDuShDpQ0a0V7k9tRr7xJhFLn6p2GPQZPN-iB0.mp3'
  : ARWEAVE_GATEWAY + 'X-dmGLDuShDpQ0a0V7k9tRr7xJhFLn6p2GPQZPN-iB0'
export const STUDIO_TESTING_MODE: boolean = false
export const STUDIO_TESTING_MODE_WEB2_USER_ID: string =
  '0x985260D82B48d8551CaF27Cf0d384eC90d4BdF1a'

export const COVER_ART_FILLER_ONE: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/D20B3A08-41E3-4EC3-8C9B-C606F3D4BAED.jpg'
export const COVER_ART_FILLER_ONE_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/D20B3A08-41E3-4EC3-8C9B-C606F3D4BAED.avif'
export const COVER_ART_FILLER_TWO: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/F5FA64FC-EF7E-4975-AA00-391E1C5C498B.jpg'
export const COVER_ART_FILLER_TWO_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/F5FA64FC-EF7E-4975-AA00-391E1C5C498B.avif'
export const COVER_ART_FILLER_THREE: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/0A1B7B19-B136-4E64-8498-C964F73ADC8F.jpg'
export const COVER_ART_FILLER_THREE_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/0A1B7B19-B136-4E64-8498-C964F73ADC8F.avif'
export const COVER_ART_FILLER_FOUR: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/BEC7A8E3-8C74-4ABF-B4B8-E474EF8BAAE2.jpg'
export const COVER_ART_FILLER_FOUR_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/BEC7A8E3-8C74-4ABF-B4B8-E474EF8BAAE2.avif'
export const COVER_ART_FILLER_FIVE: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/BEC7A8E3-8C74-4ABF-B4B8-E474EF8BAAE2.jpg'
export const COVER_ART_FILLER_FIVE_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/BEC7A8E3-8C74-4ABF-B4B8-E474EF8BAAE2.avif'
export const COVER_ART_FILLER_SIX: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/EB505D34-4B22-4EAB-B500-748FA43374A5.jpg'
export const COVER_ART_FILLER_SIX_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/EB505D34-4B22-4EAB-B500-748FA43374A5.avif'
export const COVER_ART_FILLER_SEVEN: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/34EABCC3-5013-489A-8F11-001FC53391D1.jpg'
export const COVER_ART_FILLER_SEVEN_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/34EABCC3-5013-489A-8F11-001FC53391D1.avif'
export const COVER_ART_FILLER_EIGHT: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/385A02E3-14AA-4E43-8D72-8C163F1345D5.jpg'
export const COVER_ART_FILLER_EIGHT_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/385A02E3-14AA-4E43-8D72-8C163F1345D5.avif'
export const COVER_ART_FILLER_NINE: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/F3EDEB73-B0F8-4FEB-9A83-9109FEC17C03.jpg'
export const COVER_ART_FILLER_NINE_AVIF: string =
  PRACTICAL_STREAM_CDN_ADDRESS + 'a/F3EDEB73-B0F8-4FEB-9A83-9109FEC17C03.avif'
export const MY_US_CA_STATE_DATA_ARRAY = [
  { value: 'AL', label: 'Alabama (AL)' },
  { value: 'AK', label: 'Alaska (AK)' },
  { value: 'AZ', label: 'Arizona (AZ)' },
  { value: 'AR', label: 'Arkansas (AR)' },
  { value: 'CA', label: 'California (CA)' },
  { value: 'CO', label: 'Colorado (CO)' },
  { value: 'CT', label: 'Connecticut (CT)' },
  { value: 'DE', label: 'Delaware (DE)' },
  { value: 'DC', label: 'District of Columbia (DC)' },
  { value: 'FL', label: 'Florida (FL)' },
  { value: 'GA', label: 'Georgia (GA)' },
  { value: 'HI', label: 'Hawaii (HI)' },
  { value: 'ID', label: 'Idaho (ID)' },
  { value: 'IL', label: 'Illinois (IL)' },
  { value: 'IN', label: 'Indiana (IN)' },
  { value: 'IA', label: 'Iowa (IA)' },
  { value: 'KS', label: 'Kansas (KS)' },
  { value: 'KY', label: 'Kentucky (KY)' },
  { value: 'LA', label: 'Louisiana (LA)' },
  { value: 'ME', label: 'Maine (ME)' },
  { value: 'MD', label: 'Maryland (MD)' },
  { value: 'MA', label: 'Massachusetts (MA)' },
  { value: 'MI', label: 'Michigan (MI)' },
  { value: 'MN', label: 'Minnesota (MN)' },
  { value: 'MS', label: 'Mississippi (MS)' },
  { value: 'MO', label: 'Missouri (MO)' },
  { value: 'MT', label: 'Montana (MT)' },
  { value: 'NE', label: 'Nebraska (NE)' },
  { value: 'NV', label: 'Nevada (NV)' },
  { value: 'NH', label: 'New Hampshire (NH)' },
  { value: 'NJ', label: 'New Jersey (NJ)' },
  { value: 'NM', label: 'New Mexico (NM)' },
  { value: 'NY', label: 'New York (NY)' },
  { value: 'NC', label: 'North Carolina (NC)' },
  { value: 'ND', label: 'North Dakota (ND)' },
  { value: 'OH', label: 'Ohio (OH)' },
  { value: 'OK', label: 'Oklahoma (OK)' },
  { value: 'OR', label: 'Oregon (OR)' },
  { value: 'PA', label: 'Pennsylvania (PA)' },
  { value: 'RI', label: 'Rhode Island (RI)' },
  { value: 'SC', label: 'South Carolina (SC)' },
  { value: 'SD', label: 'South Dakota (SD)' },
  { value: 'TN', label: 'Tennessee (TN)' },
  { value: 'TX', label: 'Texas (TX)' },
  { value: 'UT', label: 'Utah (UT)' },
  { value: 'VT', label: 'Vermont (VT)' },
  { value: 'VA', label: 'Virginia (VA)' },
  { value: 'WA', label: 'Washington (WA)' },
  { value: 'WV', label: 'West Virginia (WV)' },
  { value: 'WI', label: 'Wisconsin (WI)' },
  { value: 'WY', label: 'Wyoming (WY)' },
  { value: 'AB', label: 'Alberta (AB)' },
  { value: 'BC', label: 'British Columbia (BC)' },
  { value: 'MB', label: 'Manitoba (MB)' },
  { value: 'NB', label: 'New Brunswick (NB)' },
  { value: 'NL', label: 'Newfoundland and Labrador (NL)' },
  { value: 'NS', label: 'Nova Scotia (NS)' },
  { value: 'NT', label: 'Northwest Territories (NT)' },
  { value: 'NU', label: 'Nunavut (NU)' },
  { value: 'ON', label: 'Ontario (ON)' },
  { value: 'PE', label: 'Prince Edward Island (PE)' },
  { value: 'QC', label: 'Quebec (QC)' },
  { value: 'SK', label: 'Saskatchewan (SK)' },
  { value: 'YT', label: 'Yukon (YT)' },
]
export const MY_COUNTRY_DATA_ARRAY = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AX', label: 'Åland Islands' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CD', label: 'Congo (Democratic Republic)' },
  { value: 'CG', label: 'Congo (Republic)' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: "Côte d'Ivoire" },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czechia' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'VA', label: 'Holy See' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: 'Korea (North)' },
  { value: 'KR', label: 'Korea (South)' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'MK', label: 'North Macedonia' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Réunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'SH', label: 'Saint Helena' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syrian Arab Republic' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Türkiye' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'UM', label: 'United States Minor Outlying Islands' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Viet Nam' },
  { value: 'VG', label: 'Virgin Islands (British)' },
  { value: 'VI', label: 'Virgin Islands (U.S.)' },
  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
]
